<template>
    <div style="z-index: 99999;">

    <select-creator-profile-lightbox style="z-index: 99999" :exportFromCalcCard="false"/>



      <div class="lightbox" v-if="editGeneralSettings || calculation.openEditModal">
        <div class="ui-infobar--popup general-settings ui-modal--settings bg-black p3 rounded-border mt4 col-12 max-width-4 relative">
            <!-- <button class="lightbox-close-btn" @click="editGeneralSettings = false, calculation.openEditModal = false"> -->
              <button class="lightbox-close-btn" @click="checkCalculationCloseModal()">
                <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            <h2 class="h2 white mb3">{{$t('eingabe_modal_newcalc_h')}}</h2> 
            <div class="flex">
              <div class="pt3 col-8 pr3" style="border-right: 1px solid #979797">
                <div class="flex align-middle">
                  <p class="col-6 white " :class="{settingsError: not_filled_calcName}">{{$t('eingabe_modal_newcalc_nameofcalc')}}*</p>
                  <div class="col-6">
                    <input class="user-input user-input-narrow col-12 black border-box" :placeholder="$t('eingabe_modal_newcalc_nameofcalc_placeholder')" v-model="calculation.name">
                  </div>
                </div>
                <!-- <p class="p-small col-5 color-gray" style="margin-top: -.5rem;">{{$t('eingabe_modal_newcalc_nameofcalc_infotext')}}</p> -->
                <div class="flex mt1 a1align-top">
                <div class="col-6  ">

                  <p class="white "> {{$t('eingabe_modal_newcalc_description')}}</p>
                  <!-- <p class="p-small color-gray" >{{$t('eingabe_modal_newcalc_description_infotext')}}</p> -->

                </div>
                 
                  <div class="col-6">
                    <textarea rows=6 class="user-input user-input-narrow col-12 black border-box" maxlength="1000" placeholder="" v-model="calculation.description" />
                    <p class="color-gray text-right mb2">{{descStrLength}} / 1000</p>
                  </div>
                </div>
                <div class="flex align-middle mt1 mb2">
                  <p class="col-6 white " :class="{settingsError: not_filled_deckendicke}">{{$t('eingabe_modal_newcalc_ceilingthickness')}}*</p>
                  <div class="col-6 flex align-middle justify-end">
                    <p class="color-gray light mr1">cm</p>
                    <input class="user-input user-input-narrow black" v-model="inputParams.in_deckendicke">
                  </div>
                </div>
                <p class="p-small col-5 color-gray" style="margin-top: -.5rem;">{{$t('eingabe_modal_newcalc_ceilingthickness_infotext')}}</p>
                <div class="flex align-middle mb1">
                  <p class="col-6 white "> {{$t('eingabe_modal_newcalc_version')}}</p>
                  <div class="relative col-6">
                    <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
                    <select class="user-input user-input-narrow col-12 black" v-model="inputParams.in_baustoff"  @change="checkProdukteingrenzungundFugen();">
                      <option value="0" disabled>{{$t('eingabe_modal_newcalc_version_pleaseselect')}}</option>
                      <option value="Ortbeton">{{$t('eingabe_modal_newcalc_version_value_ortbeton')}}</option>
                      <option value="Halbfertigteil">{{$t('eingabe_modal_newcalc_version_value_halbfertigteil')}}</option>
                    </select>
                  </div>
                </div>
                <!-- <p class="p-small col-5 color-gray" style="margin-top: -.5rem;">{{$t('eingabe_modal_newcalc_version_infotext')}}</p> -->
                <div class="flex mb2 align-middle">
                  <p class="col-6 white ">{{$t('eingabe_modal_newcalc_standard')}}</p>
                  <div class="relative col-6">
                    <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
                    <select class="user-input user-input-narrow col-12 black" @change="checkFireSafetyNorm()" v-model="inputParams.in_verwNorm">
                      <option value="0" disabled>{{$t('eingabe_modal_newcalc_creatorprofile_pleaseselect')}}</option>
                      <option value="EC2 (DE)">EC2 (DE)</option>
                      <option value="EC2">EC2</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-7 px2 mt3">
                <div class="flex align-middle mb2">
                <img class="col-1 mr3" src="../assets/fire-icon.svg">
                <h2 class="h3 white regular left-align col-6">{{$t('eingabe_modal_newcalc_fireprevention_headlinetext')}}</h2>
                </div>
                <div class="flex mb2">
                  <p class="col-6 white ">{{$t('eingabe_modal_newcalc_fireprevention_mandatory_question')}}</p>
                  <div class="switch dark relative pointer" @click="inputParams.in_fireSafetyRequired = !inputParams.in_fireSafetyRequired, checkPanelNumber()">
                    <div class="switch-ball" :class="{sbLeft: inputParams.in_fireSafetyRequired == false}"></div>
                    <p class="switch-label-left" :class="{labelhidden: inputParams.in_fireSafetyRequired == false}">{{$t('eingabe_modal_newcalc_fireprevention_mandatory_value_yes')}}</p>
                    <p class="switch-label-right" :class="{labelhidden: inputParams.in_fireSafetyRequired == true}">{{$t('eingabe_modal_newcalc_fireprevention_mandatory_value_no')}}</p>
                  </div>
                </div>
                <div class="flex align-middle">
                <p class="col-6 white " :class="{op0: !inputParams.in_fireSafetyRequired}">{{$t('eingabe_modal_newcalc_fireprevention_proof')}}</p>
                <div class="relative col-6 mb2" :class="{op0: !inputParams.in_fireSafetyRequired}">
                  <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
                  <select class="user-input user-input-narrow col-12 black" v-model="inputParams.in_brandschutz">
                    <option value="0" disabled>{{$t('eingabe_modal_newcalc_fireprevention_proof_pleaseselect')}}</option>
                    <option value="gemaeß ABZ">{{$t('eingabe_modal_newcalc_fireprevention_proof_value_abz')}}</option>
                    <option value="gemaeß Gutachten">{{$t('eingabe_modal_newcalc_fireprevention_proof_value_evaluation')}}</option>
                  </select>
                </div>
                </div>
                <div class="flex mb2 align-middle"  :class="{op0: !inputParams.in_fireSafetyRequired}">
                  <p class="col-6 white " :class="{settingsError: not_filled_brandschutzklasse}">{{$t('eingabe_modal_newcalc_fireprevention_class')}}*</p>
                  <div class="relative col-6">
                    <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
                    <select class="user-input user-input-narrow col-12 black" v-model="inputParams.in_brandschutzklasse">
                      <option value="0" disabled>{{$t('eingabe_modal_newcalc_fireprevention_class_pleaseselect')}}</option>
                      <option value="R 30">R 30</option>
                      <option value="R 60">R 60</option>
                      <option value="R 90">R 90</option>
                      <option value="R 120">R 120</option>
                      <option value="R 180">R 180</option>
                      <option value="R 240">R 240</option>
                    </select>
                  </div>
                </div>
                <div class="flex mb2 align-middle"  :class="{op0: !inputParams.in_fireSafetyRequired}">
                  <p class="col-6 white " :class="{settingsError: not_filled_statSystem}">{{$t('eingabe_modal_newcalc_fireprevention_staticsystem')}}* </p>
                  <div class="relative col-6">
                    <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
                    <select class="user-input user-input-narrow col-12 black" v-model="inputParams.in_statSystem">
                      <option value="0" disabled>{{$t('eingabe_modal_newcalc_fireprevention_staticsystem_pleaseselect')}}</option>
                      <option value="einachsig">{{$t('eingabe_modal_newcalc_fireprevention_staticsystem_oneangle')}}</option>
                      <option value="zweiachsig |_y/|_x <= 1,5">{{$t('eingabe_modal_newcalc_fireprevention_staticsystem_twoangles1')}}</option>
                      <option value="zweiachsig 1,5 <= y/x <= 2,0">{{$t('eingabe_modal_newcalc_fireprevention_staticsystem_twoangles2')}}</option>
                    </select>
                  </div>
                </div>
                <div class="flex mb2 align-middle" :class="{op0: !inputParams.in_fireSafetyRequired}">
                  <p class="col-6 white " :class="{settingsError: not_filled_dbewehrungslage}">{{$t('eingabe_modal_newcalc_fireprevention_rod_diameter_of_hbuw')}}*</p>
                  <div class="relative col-4">
                    <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
                    <select id="dUntereBewehrungslage" name="dUntereBewehrungslage" v-model="inputParams.in_dbewehrungslageUnten" class="col-12 user-input user-input-narrow black">
                      <option value="" disabled selected ></option>
                      <option value="6">6</option>
                      <option value="8">8</option>
                      <option value="10">10</option>
                      <option value="12">12</option>
                      <option value="14">14</option>
                      <option value="16">16</option>
                      <option value="20">20</option>
                      <option value="25">25</option>
                      <option value="28">28</option>
                    </select> 
                  </div>
                  <p class="color-gray light ml1">mm</p>
                </div>
              </div>
            </div>
          
            <p class="color-red" v-show="generalSettingsValidated == false">{{$t('eingabe_modal_newcalc_warningmessage_mandatoryfieldsnotfilled')}}</p>
            <div class="p">
              <div class="flex flex-end mr2">
                <a class="btn btn-primary px4 no-arrow" @click="updateGeneralSettings()">{{$t('eingabe_modal_newcalc_btn_ok')}}</a>
              </div>
            </div>
        </div>
      </div>

      <div class="lightbox" v-show="openTable == true">
        <div class="ui-infobar--popup relative hohlkoerper-selection bg-color-darkgray pt3 pb3 pl3 rounded-border mt4" style="width: 1000px;" v-show="openTable == true">
          <button class="lightbox-close-btn" @click="openTable = false">
            <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <h2 class="h3 white regular  mb3 left-align pl2">{{$t('eingabe_modal_productselection_headline')}}</h2>
          <div class="flex">
            <div class="half-small pr2">
              <div class="select-system" :class="{activeSection: activeSystem == 'cls', npe: inputParams.in_baustoff == 'Halbfertigteil', op30: inputParams.in_baustoff == 'Halbfertigteil'}"  @click="activeSystem = 'cls'">
                <h2 class="h4 white regular  mb2">{{$t('eingabe_modal_productselection_product_cls')}}</h2>
                <img class="gridelement op70" src="../assets/CLS_new.png">
              </div>
              <div class="select-system mt2 sl-container" :class="{activeSection: activeSystem == 'sl'}" @click="activeSystem = 'sl'">
                <div class="sl-overlay-notice" v-if="$t('eingabe_modal_productselection_sl_notice')">{{$t('eingabe_modal_productselection_sl_notice')}}</div>
                <h2 class="h4 white regular  mb2">{{$t('eingabe_modal_productselection_product_sl')}}</h2>
                <img class="gridelement op70" src="../assets/SL_new.png">
              </div>
            </div>
            <div class="half-small pl1">
              <div class="selected-system pt2">
                <h2 class="h3 white regular  left-align" v-if="activeSystem !== 'sl'">Cobiax CLS</h2>
                <h2 class="h3 white regular  left-align" v-if="activeSystem !== 'cls'">Cobiax SL</h2>
                <p class="subtitle mb2"><b>{{selected_system.name}}</b></p>
                <div class="flex mb1">
                  <p class="col-8">{{$t('eingabe_modal_productselection_ceilingthickness_min')}}</p>
                  <p class="col-4 text-right"><b>{{selected_system.minDeckendicke}}</b> cm</p>
                </div>
                <div class="flex mb1">
                  <p class="col-8">{{$t('eingabe_modal_productselection_ceilingthickness_max')}}</p>
                  <p class="col-4 text-right"><b>{{selected_system.maxDeckendicke}}</b> cm</p>
                </div>
                <div class="" v-show="activeSystem == 'sl'">
                  <p class="color-gray p-tiny mb1">{{$t('eingabe_modal_productselection_ceilingthickness_addtionalsheight')}}:</p>
                  <div class="relative col-12">
                    <img class="dropdown-arrow" src="../assets/dropdown-arrow.svg">
                    <select id="sl_unterstuetzungshoehe" name="sl_unterstuetzungshoehe" v-model="inputParams.in_sl_unterstuetzungshoehe" class="col-12 user-input user-input-narrow black">
                      <option value="" disabled selected></option>
                      <option value="0">0</option>
                      <option value="20">20 mm</option>
                      <option value="30">30 mm</option>
                      <option value="40">40 mm</option>
                      <option value="50">50 mm</option>
                      <option value="60">60 mm</option>
                    </select> 
                  </div>
                </div>
              </div>
            </div>
            <div class="half-big pl2" v-show="activeSystem == 'sl'">
              <div class="col-12 table-wrapper">
                <div class="my1 flex align-middle">
                  <div class="ml2 switch relative pointer large-switch dark mt0" @click="inputParams.in_sl_onlyFittingTypes = !inputParams.in_sl_onlyFittingTypes">
                    <div class="switch-ball" :class="{sbLeft: inputParams.in_sl_onlyFittingTypes == false}"></div>
                    <p class="switch-label-right " :class="{labelhidden: inputParams.in_sl_onlyFittingTypes == true}">{{$t('eingabe_modal_productselection_checkbox_no')}}</p>
                    <p class="switch-label-left " :class="{labelhidden: inputParams.in_sl_onlyFittingTypes == false}">{{$t('eingabe_modal_productselection_checkbox_yes')}}</p>
                  </div>  
                  <label class="ml2 pointer" for="matchingSL">{{ $t('eingabe_modal_productselection_checkbox') }}</label>
                </div>
                <table class="product_select_table col-12">
                  <tr class="table-heading">
                    <td class="bold">{{$t('eingabe_modal_productselection_table_modal')}}</td>
                    <td class="bold">{{$t('eingabe_modal_productselection_table_minmaxthicknessinfo')}}</td>
                    <td class="bold">{{$t('eingabe_modal_productselection_notice')}}</td>
                    <td class="bold">{{$t('eingabe_modal_productselection_table_isusable')}}</td>
                    <td></td>
                  </tr>
                  <tr v-for="system in sl_system_collection" :key="system.id" :class="{productusable : system.status == 'usable', productshown: ((inputParams.in_sl_onlyFittingTypes == true && system.status == 'usable') || inputParams.in_sl_onlyFittingTypes == false), highlighted: system.id == selected_system.id}" @click="select_system(system)">
                    <td>{{ system.name }}</td>
                    <td>{{system.minDeckendicke}}cm /{{ system.maxDeckendicke }} cm</td>
                    <td>{{system.zusatzbemerkung}}</td>
                    <td>{{ system.status == 'usable' ? $t('eingabe_modal_productselection_table_cell_isusable') : $t('eingabe_modal_productselection_table_cell_is_not_usable') }}</td>
                  </tr>
                </table>	
              </div>
            </div>
            <div class="half-big pl2" v-show="activeSystem == 'cls'">
              <div class="col-12 table-wrapper">
                  <div class="my1 flex align-middle">
                  <div class="ml2 switch relative pointer large-switch dark mt0" @click="inputParams.in_cls_onlyFittingTypes = !inputParams.in_cls_onlyFittingTypes">
                    <div class="switch-ball" :class="{sbLeft: inputParams.in_cls_onlyFittingTypes == false}"></div>
                    <p class="switch-label-right " :class="{labelhidden: inputParams.in_cls_onlyFittingTypes == true}">{{$t('eingabe_modal_productselection_checkbox_no')}}</p>
                    <p class="switch-label-left " :class="{labelhidden: inputParams.in_cls_onlyFittingTypes == false}">{{$t('eingabe_modal_productselection_checkbox_yes')}}</p>
                  </div>  
                  <label class="ml2 pointer" for="matchingSL">{{ $t('eingabe_modal_productselection_checkbox') }}</label>
                </div>
                <table class="product_select_table col-12">
                  <tr class="table-heading">
                    <td class="bold">{{$t('eingabe_modal_productselection_table_modal')}}</td>
                    <td class="bold">{{$t('eingabe_modal_productselection_table_minmaxthicknessinfo')}}</td>
                    <td class="bold">{{$t('eingabe_modal_productselection_table_isusable')}}</td>
                    <td></td>
                  </tr>
                  <tr v-for="system in cls_system_collection" :key="system.id" :class="{productusable : system.status == 'usable', productshown: ((inputParams.in_cls_onlyFittingTypes == true && system.status == 'usable') || inputParams.in_cls_onlyFittingTypes == false), highlighted: system.id == selected_system.id}" @click="select_system(system)">
                    <td>{{ system.name }}</td>
                    <td>{{system.minDeckendicke}}cm /{{ system.maxDeckendicke }} cm</td>
                    <td>{{ system.status == 'usable' ? $t('eingabe_modal_productselection_table_cell_isusable') : $t('eingabe_modal_productselection_table_cell_is_not_usable') }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer pt3 mt3 mr2">
            <div class="flex mr4 align-middle flex-end">
              <a class="btn  btn-small btn-bg-red mr2" @click="openTable = false">{{$t('eingabe_modal_productselection_btn_cancel')}}</a>
              <a class="btn  btn-small px4" @click="openTable = false, chooseSystem()">{{$t('eingabe_modal_productselection_btn_ok')}}</a>
            </div>
          </div>
        </div>
      </div>


      <lightbox activateCommand="open_fireSafetyInfo" customClass="bg-color-darkgray rounded-border max-width-3">
            <!-- CASE NO VALID COMBINATION -->
            <div v-if="outputParams.out_sollMinAhk == 0 && outputParams.out_sollAhk == 0 && outputParams.out_sollD2Hk == 0 && outputParams.out_sollMinD2Hk == 0 && brandschutzCode == '200' && outputParams.out_fallbackValues.d2hk == 0 && outputParams.out_fallbackValues.ahk == 0">
              <p class="p-small white">{{$t('eingabe_panels_fireprevention_modal_novalidvalues')}}</p>
            </div>
            <!-- CASE NO VALID COMBINATION BUT FALBACK VALUES-->
            <div v-if="outputParams.out_sollMinAhk == 0 && outputParams.out_sollAhk == 0 && outputParams.out_sollD2Hk == 0 && outputParams.out_sollMinD2Hk == 0 && brandschutzCode == '200' && outputParams.out_fallbackValues.d2hk !== 0 && outputParams.out_fallbackValues.ahk !== 0">
              <p class="p-small white">{{$t('alertmessages_20_part_1')}} {{outputParams.out_workinValues.d2hk}}{{$t('alertmessages_20_part_2')}}{{outputParams.out_workinValues.ahk}}{{$t('alertmessages_20_part_3')}}</p>
            </div>
            <!-- CASE GENERAL INFO -->
            <div v-if="!brandschutz_achsabstand_too_small && !(outputParams.out_sollMinAhk == 0 && outputParams.out_sollAhk == 0 && outputParams.out_sollD2Hk == 0 && outputParams.out_sollMinD2Hk == 0 && brandschutzCode == '200')">
              <p class="p-small white">{{$t('eingabe_panels_fireprevention_modal_redoverlay_h')}}<br> {{$t('eingabe_panels_fireprevention_modal_redoverlay_p_1')}}
                </p>
                <ul class="ml2 white p-tiny mb1">
                  <li>{{$t('eingabe_panels_fireprevention_modal_redoverlay_p_1_ul_1')}}</li>
                  <li>{{$t('eingabe_panels_fireprevention_modal_redoverlay_p_1_ul_2')}}</li>
                  <li>{{$t('eingabe_panels_fireprevention_modal_redoverlay_p_1_ul_3')}}</li>
                  <li>{{$t('eingabe_panels_fireprevention_modal_redoverlay_p_1_ul_4')}}</li>
                </ul>
                <p class="p-small white">{{$t('eingabe_panels_fireprevention_modal_redoverlay_p_2')}}</p>
                <ul class="ml2 white p-tiny mb1">
                  <li>{{$t('eingabe_panels_fireprevention_modal_redoverlay_p_2_ul_1')}}</li>
                  <li>{{$t('eingabe_panels_fireprevention_modal_redoverlay_p_2_ul_2')}}</li>
                  <li>{{$t('eingabe_panels_fireprevention_modal_redoverlay_p_2_ul_3')}}</li>
                  <li>{{$t('eingabe_panels_fireprevention_modal_redoverlay_p_2_ul_4')}}</li>
                </ul>
                <p class="p-small white">
                  {{$t('eingabe_panels_fireprevention_modal_redoverlay_p_3')}}
                </p>
            </div>
            <!-- CASE AHK TOO SMALL -->
            <div v-if="brandschutz_achsabstand_too_small && !(outputParams.out_sollMinAhk == 0 && outputParams.out_sollAhk == 0 && outputParams.out_sollD2Hk == 0 && outputParams.out_sollMinD2Hk == 0 && brandschutzCode == '200')" >
              <p class="p-small white">{{$t('eingabe_panels_fireprevention_modal_redaxial_h')}} <br>{{$t('eingabe_panels_fireprevention_modal_redaxial_p_1')}}
                </p>
                <ul class="ml2 white p-tiny mb1">
                  <li>{{$t('eingabe_panels_fireprevention_modal_redaxial_p_1_ul_1')}}</li>
                  <li>{{$t('eingabe_panels_fireprevention_modal_redaxial_p_1_ul_2')}}</li>
                </ul>
                <p class="p-small white">{{$t('eingabe_panels_fireprevention_modal_redaxial_p_2')}}</p>
                <ul class="ml2 white p-tiny mb1">
                  <li>{{$t('eingabe_panels_fireprevention_modal_redaxial_p_2_ul_1')}}</li>
                  <li>{{$t('eingabe_panels_fireprevention_modal_redaxial_p_2_ul_2')}}</li>
                  <li>{{$t('eingabe_panels_fireprevention_modal_redaxial_p_2_ul_3')}}</li>
                  <li>{{$t('eingabe_panels_fireprevention_modal_redaxial_p_2_ul_4')}}</li>
                </ul>
                <p class="p-small white">
                  {{$t('eingabe_panels_fireprevention_modal_redaxial_p_3')}}
                </p>
            </div>
    </lightbox>


    <lightbox activateCommand="open_fireSafetyOptimizingInfo" customClass="bg-color-darkgray rounded-border max-width-3">
        <div class="relative">

            <p class="p-small white">{{$t('eingabe_panels_fireprevention_modal_allgreen_h')}} {{$t('eingabe_panels_fireprevention_modal_allgreen_p_1')}}</p>
            <!-- <ul class="white p-tiny ml2">
              <li v-show="outputParams.out_kombination_a_d2hk !== null && outputParams.out_kombination_a_d2hk > 0 && outputParams.out_kombination_a_ahk !== null && outputParams.out_kombination_a_ahk > 0"> Bei einer unteren Betonüberdeckung von {{outputParams.out_kombination_a_d2hk|formatNumber}}mm ist ein Achsabstand von {{outputParams.out_kombination_a_ahk|formatNumber}}mm ausreichend.</li>
               <li v-show="outputParams.out_kombination_b_d2hk !== null && outputParams.out_kombination_b_d2hk > 0 && outputParams.out_kombination_b_ahk !== null && outputParams.out_kombination_b_ahk > 0"> Bei einer unteren Betonüberdeckung von {{outputParams.out_kombination_b_d2hk|formatNumber}}mm ist ein Achsabstand von {{outputParams.out_kombination_b_ahk|formatNumber}}mm ausreichend.</li>
                <li v-show="outputParams.out_kombination_c_d2hk !== null && outputParams.out_kombination_c_d2hk > 0 && outputParams.out_kombination_c_ahk !== null && outputParams.out_kombination_c_ahk > 0"> Bei einer unteren Betonüberdeckung von {{outputParams.out_kombination_c_d2hk|formatNumber}}mm ist ein Achsabstand von {{outputParams.out_kombination_c_ahk|formatNumber}}mm ausreichend.</li>
            </ul> -->
            <p class="p-small white mb1">{{$t('eingabe_panels_fireprevention_modal_allgreen_p_2')}}</p>
            <div class="flex">
              <div class="mr2">
                <p class="mb1 mx-auto white center p-tiny">{{$t('eingabe_panels_fireprevention_modal_allgreen_column_1')}}</p>
                <p class="user-input user-input-ghost center bold mb1 mx-auto white" v-for="pair in outputParams.out_optimierungen" :key="'A' + pair.index">{{pair.d2hk}}</p>
              </div>
              <div>
                <p class="mb1 mx-auto white center p-tiny">{{$t('eingabe_panels_fireprevention_modal_allgreen_column_2')}}</p>
                <p class="user-input user-input-ghost center bold mb1 mx-auto white" v-for="pair in outputParams.out_optimierungen" :key="'A' + pair.index">{{pair.ahk}}</p>
              </div>
            </div>
            <p class="p-tiny white mb1">{{$t('eingabe_panels_fireprevention_modal_allgreen_p_3')}}</p>
          </div>
      </lightbox>

      <lightbox activateCommand="open_fireSafetyD2hk" customClass="bg-white rounded-border max-width-3">
        <div class="col-12 min600w" v-if="chosen_system.name.startsWith('SL') || chosen_system.name == ''">
          <img class="col-12 mr2 pointer" src="../assets/d2hk_SL.svg">
        </div>
        <div class="col-12 min600w" v-if="chosen_system.name.startsWith('CLS')">
          <img class="col-12 mr2 pointer" src="../assets/d2hk_CLS.svg">
        </div>
      </lightbox>

      <lightbox activateCommand="open_fireSafetyAhk" customClass="bg-white rounded-border max-width-3">
        <div class="col-12 min600w" v-if="chosen_system.name.startsWith('SL') || chosen_system.name == ''">
          <img class="col-12 mr2 pointer" src="../assets/ahk_SL.svg">
        </div>
        <div class="col-12 min600w" v-if="chosen_system.name.startsWith('CLS')">
          <img class="col-12 mr2 pointer" src="../assets/ahk_CLS.svg">
        </div>
      </lightbox>

    <div class="ui-infobar--container flex mt2 px4">
      <div class="col-12">

        <div class="ui-navbar flex align-middle ml2 mb3">
          <router-link class="house-button pointer" :to="'/' + this.$i18n.locale + '/projects'">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 8.4V3.5C20.5 3.22385 20.2761 3 20 3H18C17.7239 3 17.5 3.22385 17.5 3.5V5.64L13.338 1.811C13.1465 1.63437 12.8515 1.63437 12.66 1.811L1.66001 12.132C1.50816 12.2717 1.45769 12.4903 1.53294 12.6824C1.60818 12.8745 1.79369 13.0006 2.00001 13H4.50001V22.5C4.50001 23.0523 4.94772 23.5 5.50001 23.5H20.5C21.0523 23.5 21.5 23.0523 21.5 22.5V13H24C24.2061 13.0002 24.3913 12.8739 24.4663 12.6819C24.5412 12.4899 24.4907 12.2715 24.339 12.132L20.5 8.4Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </router-link>
          <div class="flex align-middle">
            <div class="ml3">
              <h3 class="caps p-tiny narrow color-gray regular">{{$t('eingabe_uinavbar_project')}}</h3>
              <router-link class="white h3 regular"  :to="'/' + this.$i18n.locale + '/calculations/' + project.id">{{project.title | truncate(30, '...')}}</router-link>
            </div>
            <svg class="px3" width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(-90deg);">
                <path d="M16.3105 1.56042L9.87155 8.00042C9.2858 8.586 8.3363 8.586 7.75055 8.00042L1.31055 1.56042" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div>
              <h3 class="caps p-tiny narrow color-gray regular">{{$t('eingabe_uinavbar_calculation')}}</h3>
              <p class="h3 regular white">{{calculation.name | truncate(25, '...')}}</p>
            </div>
          </div>
        </div>

        <div class="ui-infobar general-settings-box col-12 flex mb2 white align-middle">
          <button class="btn btn-small mr3 align-middle" style="padding-left: 1rem;" @click="editGeneralSettings = true">
            <span>
              <svg style="margin-bottom: -6px; margin-right: 1rem;" width="30" height="30" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.387 6.25333C11.6025 6.49149 11.9088 6.62736 12.23 6.62736C12.5512 6.62736 12.8574 6.49149 13.073 6.25333L13.618 5.65333C13.9399 5.29676 14.4513 5.18143 14.8951 5.36535C15.3388 5.54927 15.6187 5.99261 15.594 6.47233L15.553 7.28433C15.5364 7.60526 15.6567 7.91817 15.8839 8.1454C16.1112 8.37264 16.4241 8.49289 16.745 8.47633L17.557 8.43433C18.037 8.40952 18.4806 8.68974 18.6644 9.13387C18.8481 9.57801 18.7322 10.0897 18.375 10.4113L17.775 10.9563C17.5363 11.1714 17.4 11.4776 17.4 11.7988C17.4 12.1201 17.5363 12.4263 17.775 12.6413L18.375 13.1863C18.7322 13.5079 18.8481 14.0196 18.6644 14.4638C18.4806 14.9079 18.037 15.1881 17.557 15.1633L16.745 15.1213C16.4239 15.1047 16.1108 15.2251 15.8835 15.4526C15.6563 15.68 15.5361 15.9932 15.553 16.3143L15.594 17.1263C15.6187 17.606 15.3388 18.0494 14.8951 18.2333C14.4513 18.4172 13.9399 18.3019 13.618 17.9453L13.073 17.3453C12.8574 17.1072 12.5512 16.9713 12.23 16.9713C11.9088 16.9713 11.6025 17.1072 11.387 17.3453L10.843 17.9453C10.5208 18.3015 10.0095 18.4165 9.5658 18.2327C9.12211 18.0489 8.84195 17.606 8.86599 17.1263L8.90699 16.3143C8.92589 15.9922 8.80681 15.6773 8.57952 15.4483C8.35224 15.2193 8.03822 15.0979 7.71599 15.1143L6.90399 15.1563C6.42435 15.1804 5.9814 14.9002 5.7976 14.4565C5.6138 14.0128 5.72886 13.5015 6.08499 13.1793L6.68499 12.6343C6.92311 12.419 7.05896 12.1129 7.05896 11.7918C7.05896 11.4708 6.92311 11.1647 6.68499 10.9493L6.08499 10.4043C5.732 10.0821 5.61839 9.57349 5.80078 9.13174C5.98316 8.68999 6.42252 8.40963 6.89999 8.43033L7.71199 8.47233C8.03343 8.48977 8.34716 8.36991 8.57507 8.14257C8.80298 7.91523 8.92363 7.60181 8.90699 7.28033L8.86599 6.46833C8.84195 5.98868 9.12211 5.54573 9.5658 5.36193C10.0095 5.17813 10.5208 5.29319 10.843 5.64933L11.387 6.25333Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="12.23" cy="11.7953" r="2.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="0.75" y="1.06531" width="22.5" height="22.5" rx="1.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            {{ $t('eingabe_head_btn_settings') }}
          </button>
          <div class="mr1 ">
            <p class="p-tiny bold">{{ $t('eingabe_head_conditions_p') }}:</p>
            <p class="p-tiny bold">{{ $t('eingabe_head_fireprevention_p') }}:</p>
          </div>
          <div class=" mr3 no-shrink">
            <p class="p-tiny">{{ $t('eingabe_summary_ceilingthickness') }}: {{r_Dd}} cm | {{ $t('eingabe_summary_realization') }}: {{inputParams.in_baustoff == 'Ortbeton' ? $t('eingabe_summary_realization_in-situ') : $t('eingabe_summary_realization_semi_precast') }} | {{ $t('eingabe_summary_standard') }}: {{inputParams.in_verwNorm}}</p>
            <p v-if="inputParams.in_fireSafetyRequired" class="p-tiny">{{inputParams.in_brandschutz == 'gemaeß ABZ' ? $t('eingabe_summary_fireSafetyClass_abz') : $t('eingabe_summary_fireSafetyClass_report')}} | {{ $t('eingabe_summary_firepreventionclass')}}: {{inputParams.in_brandschutzklasse}} |  {{ $t('eingabe_summary_staticsystem')}}: {{inputParams.in_statSystem == 'einachsig' ? $t('eingabe_modal_newcalc_fireprevention_staticsystem_oneangle') : ''}}{{inputParams.in_statSystem == firesafetyVar ? $t('eingabe_modal_newcalc_fireprevention_staticsystem_twoangles1') : '' }}{{inputParams.in_statSystem == firesafetyVar2 ? $t('eingabe_modal_newcalc_fireprevention_staticsystem_twoangles2') : '' }} | {{ $t('eingabe_summary_stabdurchmesser')}} {{inputParams.in_dbewehrungslageUnten}} mm </p>
            <p v-if="!inputParams.in_fireSafetyRequired" class="p-tiny">{{$t('eingabe_summary_nofireprevention')}}</p>
          </div>
          <div class="relative">
          <reset-btn v-if="chosen_system.name !== ''" clickEvent="reset_HK" customClass="hk-reset-btn"/>
            <div class="flex pointer btn btn-small relative pl4 center" v-if="chosen_system.name !== ''" @click="openTable = true">
              <img v-if="chosen_system.name.startsWith('SL')" class="mr1 absolute top-0 left-0" style="height: 5rem; margin-bottom: 6rem;" src="../assets/SL_new.png">
              <img v-if="chosen_system.name.startsWith('CLS')" class="mr1 absolute top-0 left-0" style="height: 5rem; margin-bottom: 6rem;" src="../assets/CLS_new.png">
              <div class="p1 pl4">
                <p class="white small nowrap">{{chosen_system.name.startsWith('SL') ? chosen_system_translated : chosen_system.name}}</p>
              </div>
            </div>
          </div>
          <div class="flex" v-if="chosen_system.name == '' && filledGeometry">
            <a class="btn btn-small center" @click="openTable = true">{{ $t('eingabe_head_btn_selectproduct')}}</a>
          </div>
          <div class="flex" v-if="chosen_system.name == '' && filledGeometry == false">
            <a class="btn btn-tiny center npe btn-bg-gray red-border">{{ $t('eingabe_head_btn_fillGeometry')}}</a>
          </div>
        </div>

        <div class="white mb3 col-10 lg-col-8  ui-infobar--briefingdetails small pl3">
          <small v-show="activePanel == 1 && inputParams.in_fireSafetyRequired == true" class="h7 small">
            {{ $t('eingabe_infotext_page_1_withfireprevention_p') }}
          </small>
          <small v-show="activePanel == 1 && inputParams.in_fireSafetyRequired == false" class="h7 small">
            {{ $t('eingabe_infotext_page_1_withoutfireprevention_p') }}
          </small>
          <small v-show="activePanel == 2" class="h7 small">
            {{ $t('eingabe_infotext_page_2_p') }}
          </small>
        </div>
      </div>
      <div class="flex-auto"></div>
      <div class="ui-infobar--message-box self-end  ml3 white p1 mb3 col-4 " style="max-width:440px">
        <div v-for="message in alertMessages" :key="message.id">
          <div class="flex mb1 pb1" style="border-bottom: 1px solid #f4f4f4;" v-if="((message.importance != 'critical' && alertMessages_SkipNoneGeometric == false) || message.importance == 'critical')">
            <div class="warn-dot mr2 relative" :class="message.importance">
              <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12C8.90111 12 8.80444 12.0293 8.72221 12.0843C8.63999 12.1392 8.5759 12.2173 8.53806 12.3087C8.50022 12.4 8.49032 12.5006 8.50961 12.5975C8.5289 12.6945 8.57652 12.7836 8.64645 12.8536C8.71637 12.9235 8.80546 12.9711 8.90245 12.9904C8.99944 13.0097 9.09998 12.9998 9.19134 12.9619C9.2827 12.9241 9.36079 12.86 9.41573 12.7778C9.47068 12.6956 9.5 12.5989 9.5 12.5C9.5 12.3674 9.44732 12.2402 9.35355 12.1464C9.25979 12.0527 9.13261 12 9 12Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 10V5" stroke="white" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="white" stroke-miterlimit="10"/>
              </svg>
            </div>
            <p v-html="message.text"></p>
          </div>
        </div>
      </div>
    </div>



    <div class="ui-content relative mb3">

      <div :class="{hidden: activePanel > 1 || (activePanel > 1 && inputParams.in_fireSafetyRequired == false ) || !filledGeometry}" @click="switchPanel(1)" class="bg-color-cta p1 forward-arrow" style="border-radius: 30px; height:30px; width:30px">
        <svg width="18" height="18" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(-90deg);">
            <path d="M16.3105 1.56042L9.87155 8.00042C9.2858 8.586 8.3363 8.586 7.75055 8.00042L1.31055 1.56042" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <div :class="{hidden: activePanel == 1}" @click="switchPanel(-1)" class="bg-color-cta p1 backward-arrow" style="border-radius: 30px; height:30px; width:30px">
        <svg width="18" height="18" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(90deg);">
              <path d="M16.3105 1.56042L9.87155 8.00042C9.2858 8.586 8.3363 8.586 7.75055 8.00042L1.31055 1.56042" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
      </div>


      <div class="ui-content--slide flex col-12 px1" :class="{panelActive: activePanel == 1, panelForward: activePanel !== 1}">

        <div class="ui-content--box ui-geometrie-kachel " :class="{'red-border': filledGeometry == false && chosen_system.name == ''}">
          <h3 class="h2 mb2">{{ $t('eingabe_panels_geometry_headline') }}</h3>
          <reset-btn clickEvent="reset_Geometry"/>
          <p class="color-gray p mb2">{{$t('eingabe_panels_geometry_actual_height')}} <span class="bold white ml1">{{r_usedDeckendicke|formatNumber}}</span> cm<span class="white bold ml2">{{differenzDeckendicke >= 0 ? '+' : ''}} {{r_differenzDeckendicke|formatNumber}}</span> cm</p>
          <div class="flex mb1 align-middle justify-between">
            <p class="col-6 ">{{ $t('eingabe_panels_geometry_concretecoverabove') }}</p>
            <div class="flex align-middle">
              <p class="color-gray light mr1">cm</p>
              <input class="user-input user-input-narrow" type="text" min="0" v-model="inputParams.in_betondeckungOben" @focus="$event.target.select()"/>
            </div>
          </div>
          <div class="flex mb1 relative align-middle justify-between">
            <div class="flex align-middle col-8 justify-between">
              <p class=" no-shrink">{{ $t('eingabe_panels_geometry_reinforcementabove') }}</p>
              <tooltip :headline="$t('eingabe_panels_geometry_reinforcementabove')" :paragraph="$t('eingabe_panels_geometry_reinforcementabove_info')" />
            </div>
            <div class="flex align-middle col-4 flex-end">
              <p class="color-gray light mr1">cm</p>
              <input class="user-input user-input-narrow" type="text" min="0" v-model="inputParams.in_bewehrungOben" @focus="$event.target.select()"/>
            </div>
          </div>
          <div class="flex mb1 relative align-middle justify-between" v-if="inputParams.in_baustoff == 'Ortbeton'">
            <div class="flex align-middle col-8 justify-between">
              <p class=" no-shrink">{{ $t('eingabe_panels_geometry_reinforcementbelow') }}</p>
               <tooltip :headline="$t('eingabe_panels_geometry_concretecoverbelow')" :paragraph="$t('eingabe_panels_geometry_reinforcementbelow_info')" />
            </div>
            <div class="flex align-middle col-4 flex-end">
              <p class="color-gray light mr1">cm</p>
              <input class="user-input user-input-narrow" type="text" min="0" v-model="inputParams.in_bewehrungUnten" @focus="$event.target.select()"/>
            </div>
          </div>
          <div class="flex mb1 align-middle justify-between" v-if="inputParams.in_baustoff == 'Halbfertigteil'">
            <div class="flex align-middle col-8 justify-between">
              <p class="no-shrink ">{{ $t('eingabe_panels_geometry_lateralreinforcement')}} </p>
              <tooltip :headline="$t('eingabe_panels_geometry_lateralreinforcement')" :paragraph="$t('eingabe_panels_geometry_crossreinforcement_info')" />
            </div>
            <div class="flex align-middle col-4 flex-end">
              <p class="color-gray light mr1">cm</p>
              <input class="user-input user-input-narrow" type="text" v-model="inputParams.in_querbewehrung"/>
            </div>
          </div>
          <div class="flex mb1 align-middle justify-between" v-if="inputParams.in_baustoff == 'Halbfertigteil'">
            <p class="col-6 ">{{ $t('eingabe_panels_geometry_thicknesssemifinisedcomponents') }}</p>
            <div class="flex align-middle">
              <p class="color-gray light mr1">cm</p>
              <input class="user-input user-input-narrow" type="text" v-model="inputParams.in_dickeHalbfertigteil"/>
            </div>
          </div>
          <div class="flex mb1 align-middle justify-between">
            <div class="flex align-middle col-8 justify-between">
              <p class="no-shrink ">{{ $t('eingabe_panels_geometry_concretecoverbelow') }}</p>
                <tooltip v-show="inputParams.in_baustoff == 'Halbfertigteil'" :headline="$t('eingabe_panels_geometry_concretecoverbelow')" :paragraph="$t('eingabe_panels_geometry_concretecoverbelow_info')" />
            </div>
            <div class="flex align-middle">
              <p class="color-gray light mr1">cm</p>
              <input class="user-input user-input-narrow" type="text" min="0" v-model="inputParams.in_betondeckungUnten" @focus="$event.target.select()"/>
            </div>
          </div>
        </div>

        <div class="ui-content--box ui-zwischenlage-kachel mx2">
          <h3 class="h2 mb2">{{ $t('eingabe_panels_intermediatelayer_headline') }}</h3>
          <reset-btn clickEvent="reset_interLayer"/>
            <div class="flex align-middle justify-between">
              <div class="flex justify-between col-8">
                <p class="no-shrink">{{$t('eingabe_panels_intermediatelayer_layertop')}}</p>
                <tooltip :headline="$t('eingabe_panels_intermediatelayer_layertop')" :paragraph="$t('eingabe_panels_intermediatelayer_layertopinfo')" />   
              </div>
              <div class="flex align-middle justify-end col-4 no-shrink">    
                <p class="color-gray light pr1">cm</p>
                <input class="user-input user-input-narrow" type="text" min="0" v-model="inputParams.in_zwlObenHoehe" @focus="$event.target.select()"/>
              </div>
            </div>
            <div class="flex mb1 align-middle justify-between mt2">
              <div class="flex justify-between col-8">
                <p class="color-white ">{{$t('eingabe_panels_intermediatelayer_cablerun_top')}}</p>
                <tooltip headline="" :paragraph="$t('eingabe_panels_intermediatelayer_cablerun_bottom_info')"/>
              </div>
              <div class="col-4 no-shrink flex flex-end">
                <div class="switch relative pointer large-switch mt0 color-switched" @click="inputParams.in_leitungsfuehrungOben = !inputParams.in_leitungsfuehrungOben">
                  <div class="switch-ball switch-ball-switched" :class="{sbLeftSwitched: inputParams.in_leitungsfuehrungOben == false}"></div>
                  <p class="switch-label-right switch-label-right-switched" :class="{labelhidden: inputParams.in_leitungsfuehrungOben == true}">{{$t('eingabe_panels_intermediatelayer_cablerun_top_value_no')}}</p>
                  <p class="switch-label-left switch-label-left-switched" :class="{labelhidden: inputParams.in_leitungsfuehrungOben == false}">{{$t('eingabe_panels_intermediatelayer_cablerun_top_value_yes')}}</p>
                </div>  
              </div> 
            </div>
            <div class="divider mx0 my2"></div>
            <div class="flex align-middle justify-between">
              <div class="flex justify-between col-8">
                <p class=" ">{{$t('eingabe_panels_intermediatelayer_layerbottom')}}</p>
                <tooltip :headline="$t('eingabe_panels_intermediatelayer_layerbottom')" :paragraph="$t('eingabe_panels_intermediatelayer_layerbottom_info')" />  
              </div>
              <div class="flex col-4 justify-end flex-center align-middle">
                <p class="color-gray light mr1">cm</p>
                <input class="user-input user-input-narrow" type="text" min="0" v-model="inputParams.in_zwlUntenHoehe" @focus="$event.target.select()"/>
              </div>
              
            </div>
            <div class="flex mb1 align-middle justify-between mt2">
              <div class="flex justify-between col-8">
                <p class="color-white ">{{$t('eingabe_panels_intermediatelayer_cablerun_bottom')}}</p>
                <tooltip headline="" :paragraph="$t('eingabe_panels_intermediatelayer_cablerun_bottom_info')"/>
              </div>
              <div class="col-4 no-shrink flex flex-end">
                <div class="switch relative pointer large-switch mt0" @click="inputParams.in_leitungsfuehrungUnten = !inputParams.in_leitungsfuehrungUnten">
                  <div class="switch-ball switch-ball-switched" :class="{sbLeftSwitched: inputParams.in_leitungsfuehrungUnten == false}"></div>
                  <p class="switch-label-right switch-label-right-switched" :class="{labelhidden: inputParams.in_leitungsfuehrungUnten == true}">{{$t('eingabe_panels_intermediatelayer_cablerun_bottom_value_no')}}</p>
                  <p class="switch-label-left switch-label-left-switched" :class="{labelhidden: inputParams.in_leitungsfuehrungUnten == false}">{{$t('eingabe_panels_intermediatelayer_cablerun_bottom_value_yes')}}</p>
                </div>  
              </div> 
            </div>
            <div class="divider mx0 my2"></div>
          <div class="mt2 flex col-8 justify-between">  
          <p class="p-tiny color-gray" v-if="(inputParams.in_leitungsfuehrungOben == true || inputParams.in_leitungsfuehrungUnten == true)">{{$t('eingabe_panels_intermediatelayer_query_sentence_part_1')}} {{((inputParams.in_leitungsfuehrungOben == true) ? 25 : 0) + ((inputParams.in_leitungsfuehrungUnten == true) ? 25 : 0) }} {{$t('eingabe_panels_intermediatelayer_query_sentence_part_2')}}</p>
          </div>
        </div>


        <div class="ui-content--box ui-grafik-kachel h100 relative front overflow-hidden" :class="{'border-red': differenzDeckendicke < 0}">
          <h2 class="h4 mb2" style="margin-top: -1rem;">{{$t('eingabe_panels_graphic_headline_part_1')}} <span class="p color-gray ml1">{{$t('eingabe_panels_graphic_headline_part_2')}}</span></h2>
          <grafik
            :BetondeckungOben="f_bdO"
            :BewehrungOben="f_bewO"
            :BetondeckungUnten="f_bdU"
            :BewehrungUnten="f_bewU"
            :Hohlkoerper="chosen_system"
            :zwischenlageUnten="f_zwlU"
            :zwischenlageOben="f_zwlO"
            :dickeHalbfertigteil="f_DHFT"
            :baustoff="inputParams.in_baustoff"
            :deckendicke="f_Dd"
            :querbewehrung="f_QB"
            :sl_unterstuetzungshoehe="(Number(inputParams.in_sl_unterstuetzungshoehe)/10)"
            :activeSystem="activeSystem"
            :chosen_system_translated="chosen_system_translated"
            :differenzDeckendicke="differenzDeckendicke"
          />
        </div>

        <div class="ui-content--box ui-brandschutz-kachel ml2" v-if="inputParams.in_fireSafetyRequired == true && this.chosen_system.name !== ''">
          <div class="flex flex-column justify-between h100">
            <div>
              <div class="flex align-middle mb1 col-12 color-red">
                <img class="mr1 col-1 pb1" style="margin-top: -0.5rem;" src="../assets/fire-icon.svg">
               
                  <div class="colo-11" v-show="outputParams.out_checkNachweis == false">
                     <h3 class="h4  color-red mr1">{{$t('eingabe_panels_fireprevention_headline')}}</h3>
                    <p class=" color-red mb2">{{$t('eingabe_panels_fireprevention_subline_no')}}</p>
                  </div>
                  <div class="col-11" v-show="outputParams.out_checkNachweis == true">
                     <h3 class="h4 color-green mr1">{{$t('eingabe_panels_fireprevention_headline')}}</h3>
                    <p class="color-green mb2">{{$t('eingabe_panels_fireprevention_subline_yes')}}</p>
                  </div>
              </div>
     
              <div class="flex col-12 mt1 flex-wrap mt1">
                <div class="col-6" v-if="chosen_system.name.startsWith('SL') || chosen_system.name == ''">
                  <img class="col-9 mr2 pointer" @click="EBusEmit('open_fireSafetyD2hk')" src="../assets/d2hk_SL.svg">
                </div>
                <div class="col-6" v-if="chosen_system.name.startsWith('CLS')">
                  <img class="col-9 mr2 pointer" @click="EBusEmit('open_fireSafetyD2hk')" src="../assets/d2hk_CLS.svg">
                </div>
                <div class=" col-6">
                <!-- <div class="flex align-middle justify-between color-red rounded-border" :class="{'color-green': (outputParams.out_ueberdeckung >= outputParams.out_sollMinD2Hk && outputParams.out_sollMinD2Hk !== 0 && outputParams.out_sollD2Hk == 0 && brandschutzCode == '200') || (outputParams.out_sollD2Hk == 0 && outputParams.out_sollMinD2Hk == 0 && (outputParams.out_sollAhk !== 0 || outputParams.out_sollMinAhk !== 0) && brandschutzCode == '200')}"> -->
                <div class="flex align-middle justify-between color-red rounded-border" :class="{'color-green': brandschutzCode == '200' && outputParams.out_checkNachweis == true}">
                <div class="col-12 relative">
                  <div class="flex">
                    <p class="" v-html="$t('eingabe_panels_fireprevention_concreteoverlay')"></p>
                  </div>
                </div>
                <div class="flex flex-column">
                  <p class=" p-big result-value text-right">{{outputParams.out_ueberdeckung|formatNumber}} </p>
                  <p class=" small  p-tiny text-right"> {{$t('eingabe_panels_fireprevention_concreteoverlay_info_part_3')}}</p>
                </div>
              </div>
                <div v-show="outputParams.out_ueberdeckung < outputParams.out_sollD2Hk" class="col-12 p-tiny light">{{$t("eingabe_panels_fireprevention_axialdistance_reached_part_1")}}{{outputParams.out_achsabstand|formatNumber}}{{$t("eingabe_panels_fireprevention_axialdistance_reached_part_2")}}<span class="bold">{{outputParams.out_sollD2Hk|formatNumber}}{{$t("eingabe_panels_fireprevention_axialdistance_reached_part_3")}}</span>{{$t("eingabe_panels_fireprevention_axialdistance_reached_part_4")}}</div>
                <div v-show="outputParams.out_ueberdeckung > outputParams.out_sollMinD2Hk && outputParams.out_sollMinD2Hk !== 0 && outputParams.out_sollD2Hk == 0" class="col-12 p-tiny light">{{$t('eingabe_panels_fireprevention_concreteoverlay_info_part_1')}} {{outputParams.out_achsabstand|formatNumber}} {{$t('eingabe_panels_fireprevention_concreteoverlay_info_part_2')}} <span class="bold">{{outputParams.out_sollMinD2Hk|formatNumber}}{{$t('eingabe_panels_fireprevention_concreteoverlay_info_part_3')}}</span> {{$t('eingabe_panels_fireprevention_concreteoverlay_info_part_4')}}</div>
                <div v-show="outputParams.out_sollMinAhk == 0 && outputParams.out_sollAhk == 0 && outputParams.out_sollD2Hk == 0 && outputParams.out_sollMinD2Hk == 0 && brandschutzCode == '200'" class="col-12 p-tiny light"></div>
              </div>
              </div>
              <div class="flex col-12  flex-wrap mt1">
                <div class="col-6" v-if="chosen_system.name.startsWith('SL') || chosen_system.name == ''">
                  <img class="col-9 mr2 pointer" @click="EBusEmit('open_fireSafetyAhk')" src="../assets/ahk_SL.svg">
                </div>
                <div class="col-6" v-if="chosen_system.name.startsWith('CLS')">
                  <img class="col-9 mr2 pointer" @click="EBusEmit('open_fireSafetyAhk')" src="../assets/ahk_CLS.svg">
                </div>
                <div class=" col-6">
                <!-- <div class="flex align-middle col-12 box-border justify-between color-red rounded-border " :class="{'color-green': (outputParams.out_achsabstand >= outputParams.out_sollMinAhk && outputParams.out_sollMinAhk !== 0 && outputParams.out_sollAhk == 0 && brandschutzCode == '200') || (outputParams.out_sollAhk == 0 && outputParams.out_sollMinAhk == 0 && (outputParams.out_sollD2Hk !== 0 || outputParams.out_sollMinD2Hk !== 0) && brandschutzCode == '200')}"> -->
                  <div class="flex align-middle col-12 box-border justify-between color-red rounded-border " :class="{'color-green': brandschutzCode == '200' && outputParams.out_checkNachweis == true}">
                <div class="col-12 relative">
                  <p class="" v-html="$t('eingabe_panels_fireprevention_axialdistance')"></p>
                </div>
                <div class="flex flex-column ">
                  <p class=" p-big result-value text-right">{{outputParams.out_achsabstand|formatNumber}}</p>
                  <p class="small  p-tiny text-right "> {{$t('eingabe_panels_fireprevention_mm')}}</p>
                </div>
              </div>
                <div v-show="outputParams.out_achsabstand < outputParams.out_sollAhk" class="col-12 p-tiny light">{{$t('eingabe_panels_fireprevention_concreteoverlay_reached_part_1')}}{{outputParams.out_ueberdeckung|formatNumber}}{{$t('eingabe_panels_fireprevention_concreteoverlay_reached_part_2')}}<span class="bold">{{outputParams.out_sollAhk|formatNumber}}{{$t('eingabe_panels_fireprevention_concreteoverlay_reached_part_3')}}</span>{{$t('eingabe_panels_fireprevention_concreteoverlay_reached_part_4')}}</div>
                <div v-show="outputParams.out_achsabstand > outputParams.out_sollMinAhk && outputParams.out_sollMinAhk !== 0 && outputParams.out_sollAhk == 0" class="col-12 p-tiny light">{{$t('eingabe_panels_fireprevention_axialdistance_info_part_1')}}{{outputParams.out_ueberdeckung|formatNumber}}{{$t('eingabe_panels_fireprevention_axialdistance_info_part_2')}}<span class="bold">{{outputParams.out_sollMinAhk|formatNumber}}{{$t('eingabe_panels_fireprevention_axialdistance_info_part_3')}}</span> {{$t('eingabe_panels_fireprevention_axialdistance_info_part_4')}}</div>
                <div v-show="outputParams.out_sollMinAhk == 0 && outputParams.out_sollAhk == 0 && outputParams.out_sollD2Hk == 0 && outputParams.out_sollMinD2Hk == 0 && brandschutzCode == '200'" class="col-12 p-tiny light"></div>

              </div>
              </div>
            </div>
            <div class="flex flex-end mt1">
              <button v-show="outputParams.out_checkNachweis == false" class="btn btn-tiny" @click="EBusEmit('open_fireSafetyInfo')">{{$t('eingabe_panels_fireprevention_btn_youroptions_1')}}</button>
              <button v-show="outputParams.out_checkNachweis == true" class="btn btn-tiny btn-bg-green" @click="optimizeFireSafety()">{{$t('eingabe_panels_fireprevention_btn_optimization_potential')}}</button>
            </div>   
          </div>
        </div>

      </div>

      <div class="ui-content--slide flex pl4 col-12" :class="{panelActive: activePanel == 2, panelForward: activePanel > 2}">
        <div class="ui-content--box  ui-vorwerte-kachel">
          <h3 class="h2 mb2">{{ $t('eingabe_panels_preliminaryvaluesformeasurement_headline') }}</h3>
         <reset-btn clickEvent="reset_Vorwerte"/>
          <div class="flex mb1 align-middle justify-between">
            <p class="col-6 bold">{{$t('eingabe_panels_preliminaryvaluesformeasurement_concretestiffnessclass')}}</p>
            <div class="relative">
              <img class="dropdown-arrow" src="../assets/dropdown-arrow-white.svg">
              <select id="Betonfestigkeitsklasse" name="Betonfestigkeitsklasse" v-model="inputParams.in_betonfestigkeitsklasse" class="col-12 user-input user-input-narrow">
                <option value="" disabled selected >{{$t('eingabe_panels_preliminaryvaluesformeasurement_concretestiffnessclass_pleaseselect')}}</option>
                <option value="C 20/25">C 20/25</option>
                <option value="C 25/30">C 25/30</option>
                <option value="C 30/37">C 30/37</option>
                <option value="C 35/45">C 35/45</option>
                <option value="C 40/50">C 40/50</option>
                <option value="C 45/55">C 45/55</option>
              </select> 
            </div>
          </div>
          <div class="flex mb1 align-middle justify-between">
            <p class="col-6 bold">{{$t('eingabe_panels_preliminaryvaluesformeasurement_specweights')}}</p>
            <div class="col-4 flex justify-end align-middle">
            <p class="color-gray light mr1">kN/m<sup>3</sup></p>
            <input class="user-input user-input-narrow" type="text" v-model="inputParams.in_wichte" @focus="$event.target.select()"/>
            </div>
          </div>
          <div class="flex align-middle relative col-12">
            <p class="col-6 bold">{{$t('eingabe_panels_preliminaryvaluesformeasurement_effectivedepth')}}</p>
            <!-- <div class="switch relative pointer mr2 large-switch black no-shrink mt0 locked-switch" @click="inputParams.in_multiplyDeckendicke = !inputParams.in_multiplyDeckendicke" :class="{'locked-switch': inputParams.in_leitungsfuehrungOben == true || inputParams.in_leitungsfuehrungUnten == true}">
              <div class="switch-ball switch-ball-switched" :class="{'sbLeft-switched': inputParams.in_multiplyDeckendicke == true}"></div>
              <p class="switch-label-left switch-label-left-switched"  :class="{labelhidden: inputParams.in_multiplyDeckendicke == true}">{{$t('eingabe_panels_preliminaryvaluesformeasurement_effectivedepth_free')}}</p>
              <p class="switch-label-right switch-label-right-switched" :class="{labelhidden: inputParams.in_multiplyDeckendicke == false}">{{$t('eingabe_panels_preliminaryvaluesformeasurement_effectivedepth_auto')}}</p>
            </div> -->
            

            <div class="flex align-middle justify-end col-6">
              <p class="color-gray light mr1">cm</p>
              <input v-if="inputParams.in_multiplyDeckendicke == false" class="user-input user-input-narrow" type="text" v-model="inputParams.in_statNutzhoehe"/>
              <p class="result-value white p-big text-right pr1 border-box" v-if="inputParams.in_multiplyDeckendicke == true">{{(f_Dd * 0.85)|formatNumber}}</p>
            </div>
             <p class="color-gray p-tiny" style="position: absolute; bottom: -.4rem; left: 0;" v-if="inputParams.in_multiplyDeckendicke">{{$t('eingabe_panels_preliminaryvaluesformeasurement_effectivedepth_ceilingdensity')}}</p>
          </div>
          <div class="flex mb1 relative align-middle">
            <div v-if="cablerun_reduced_ceiling <= 40 && cablerun_reduced_ceiling < f_Dd && chosen_system.name.startsWith('SL')" class="mt2 flex align-middle col-8 justify-between">
              <div class="white p-tiny">
                {{$t('eingabe_panels_preliminaryvaluesformeasurement_effectivedepth_hint_sl_normal_part_1')}}{{cablerun_reduced_ceiling|formatNumber}}{{$t('eingabe_panels_preliminaryvaluesformeasurement_effectivedepth_hint_sl_normal_part_2')}}
              </div>
              <tooltip headline="" :paragraph="$t('eingabe_panels_preliminaryvaluesformeasurement_effectivedepth_hint_sl_info_normal')" />
            </div>
            <div v-if="cablerun_reduced_ceiling > 40 && chosen_system.name.startsWith('SL')" class="mt2 flex align-middle col-8 justify-between">
              <div class="white p-tiny">
                {{$t('eingabe_panels_preliminaryvaluesformeasurement_effectivedepth_hint_sl')}}
              </div>
              <tooltip headline="" :paragraph="$t('eingabe_panels_preliminaryvaluesformeasurement_effectivedepth_hint_sl_info')" />
            </div>
            <div v-if="cablerun_reduced_ceiling <= 76 && cablerun_reduced_ceiling < f_Dd && chosen_system.name.startsWith('CLS')" class=" mt2 flex align-middle col-8 justify-between">
              <div class="white p-tiny">
                {{$t('eingabe_panels_preliminaryvaluesformeasurement_effectivedepth_hint_cls_normal_part_1')}}{{cablerun_reduced_ceiling|formatNumber}}{{$t('eingabe_panels_preliminaryvaluesformeasurement_effectivedepth_hint_cls_normal_part_2')}}
              </div>
              <tooltip headline="" :paragraph="$t('eingabe_panels_preliminaryvaluesformeasurement_effectivedepth_hint_cls_info_normal')" />
            </div>
            <div v-if="cablerun_reduced_ceiling > 76 && chosen_system.name.startsWith('CLS')" class=" mt2 flex align-middle col-8 justify-between">
              <div class="white p-tiny">
                {{$t('eingabe_panels_preliminaryvaluesformeasurement_effectivedepth_hint_cls')}}
              </div>
              <tooltip headline="" :paragraph="$t('eingabe_panels_preliminaryvaluesformeasurement_effectivedepth_hint_cls_info')" />
            </div>
          </div>
        </div>

        <div class="ui-content--box ui-querkraft-kachel mx2">
          <h3 class="h2 mb2">{{ $t('eingabe_panels_verificationtransverseforce_headline') }}</h3>
          <reset-btn clickEvent="reset_bbw"/>
          <div class="flex mb1 relative align-middle justify-between">
            <div class="flex align-middle col-8 justify-between">
              <p class="bold">{{$t('eingabe_panels_verificationtransverseforce_factor')}}</p>
              <tooltip :headline="$t('eingabe_panels_verificationtransverseforce_factor')" :paragraph="$t('eingabe_panels_verificationtransverseforce_factor_info')" />
            
            </div>
            <p class="col-4 result-value text-right white border-box p-big pr1">{{outputParams.out_querkraftfaktor|formatNumber}}</p>
          </div>
          <div class="flex mb1 relative align-middle justify-between">
            <div class="flex align-middle col-8 justify-between">
              <p class="bold">{{$t('eingabe_panels_verificationtransverseforce_flexuraltensionproof')}}</p>
              <tooltip :headline="$t('eingabe_panels_verificationtransverseforce_flexuraltensionproof')" :paragraph="$t('eingabe_panels_verificationtransverseforce_flexuraltensionproof_infotext')"/>
            </div>
            <div class="col-4 flex align-middle relative flex-end">
              <p class="color-gray light mr1">cm<sup>2</sup>/m</p>
              <input class="user-input user-input-narrow" type="text" v-model="inputParams.in_biegezugbewehrung" @focus="$event.target.select()" />
            </div>
          </div>
          <div class="panel-divider bg-color-gray my3"></div>
          <h2 class="h2 white">{{$t('eingabe_panels_verificationtransverseforce_shearjoint_headline')}}</h2>
          <div class="flex mb2 align-middle justify-between">
            <div class="flex justify-between col-8">

              <p class="no-shrink bold">{{ $t('console_cqlpdfreport_joint_quality') }}</p>
                <tooltip v-show="inputParams.in_fugenbeschaffenheit == 'glatt'" :headline="$t('eingabe_panels_verificationtransverseforce_shearjoint_headline')" :paragraph="$t('eingabe_panels_verificationtransverseforce_shearjoint_smooth_infotext')"/>
                <tooltip v-show="inputParams.in_fugenbeschaffenheit == 'rau'" :headline="$t('eingabe_panels_verificationtransverseforce_shearjoint_headline')" :paragraph="$t('eingabe_panels_verificationtransverseforce_shearjoint_rough_infotext')"/>     
              </div>
            <p v-show="inputParams.in_fugenbeschaffenheit == 'glatt'" class="text-right white result-value p-big">{{$t('eingabe_panels_verificationtransverseforce_shearjoint_smooth')}}</p>
            <p v-show="inputParams.in_fugenbeschaffenheit == 'rau'" class="text-right white result-value p-big">{{$t('eingabe_panels_verificationtransverseforce_shearjoint_rough')}}</p>
          </div>
        </div>
        <div class="ui-content--box ui-grafik-kachel relative bg-white" :class="{'border-red': differenzDeckendicke < 0}" style="width: 46%">
          <h2 class="h4 mb2" style="margin-top: -1rem;">{{$t('eingabe_panels_graphic_headline_part_1')}} <span class="p color-gray ml1">{{$t('eingabe_panels_graphic_headline_part_2')}}</span></h2>
          <grafik
            :BetondeckungOben="f_bdO"
            :BewehrungOben="f_bewO"
            :BetondeckungUnten="f_bdU"
            :BewehrungUnten="f_bewU"
            :Hohlkoerper="chosen_system"
            :zwischenlageUnten="f_zwlU"
            :zwischenlageOben="f_zwlO"
            :dickeHalbfertigteil="f_DHFT"
            :baustoff="inputParams.in_baustoff"
            :deckendicke="f_Dd"
            :querbewehrung="f_QB"
            :sl_unterstuetzungshoehe="(Number(inputParams.in_sl_unterstuetzungshoehe)/10)"
            :activeSystem="activeSystem"
            :chosen_system_translated="chosen_system_translated"
            :differenzDeckendicke="differenzDeckendicke"
          />
        </div>
      </div>
    </div>

    <div class="ui-bottombar col-12 ">
    <div class="justify-center flex   white mx-auto  ">
      <div class="ui-bottombar--box  box-shaodw-big rounded-border items-center align-center flex px3  white">
          <div class="pl2 border-right">
            <div class="flex mb1 align-middle pr2 ">
              <p class="mr1">{{ $t('resultbar_result1_text') }}</p>
              <p class="h1 light white">{{(chosen_system.name !== '' && f_W >= 21 ? outputParams.out_eigengewicht : '-,--')}}</p>         
              <p class="color-gray light ml1">kN/m<sup>2</sup></p>
            </div>
          </div>
          <div class="pl2 light-border-right">
            <div class="flex mb1 align-middle pr2 ">
              <p class="mr1">{{ $t('resultbar_result2_text') }}</p>
              <p class="h1 light white">{{(chosen_system.name !== '' && f_W >= 21 ? outputParams.out_lastreduktion : '-,--')}}</p>
              <p class="color-gray light ml1">kN/m<sup>2</sup></p>
            </div>
          </div>
          <div class="light-border-right pl2">
            <div class="flex mb1 align-middle pr2 ">
              <p class="mr1">{{$t('resultbar_result3_text')}}<br><span class="color-mediumgray" v-html="'V<sub>Rd,c,cobiax</sub>'"></span></p>
              <p class="h1 light white">{{(chosen_system.name !== '' && filledGeometry && this.f_Bbw > 0 ? outputParams.out_querkrafttragfaehigkeitCobiax : '-,--')}}</p>
              <p class="color-gray light ml1">kN/m</p>
            </div>
          </div>
          <div class="pl2">
            <div class="flex mb1 align-middle pr2 ">
              <p class="mr1">{{ $t('resultbar_result4_text') }}</p>
              <p class="h1 light white">{{(chosen_system.name !== '' && filledGeometry && r_differenzDeckendicke == 0 ? outputParams.out_steifigkeitsfaktor : '-,--')}}</p>
            </div>
          </div>
      </div>
      <div class="flex-auto "></div>
      <div class="ui-bottombar--box   flex    white ">
        <button class="btn btn-primary self-center save-btn " @click="dummySave()">{{$t('eingabe_savebtn_btn_text')}}</button>
      </div>
      <div class="ui-bottombar--box rounded-border flex px3 py3  white ml2 op0 pdf-export-button-holder" :class="{op100: activePanel >= 2 || (activePanel == 2 && inputParams.in_fireSafetyRequired == false), 'no-pointer-events': activePanel < 2}">
          <div class="">
            <pdf-export-buttons 
              :calcName="calculation.name" 
              :calcDescription="calculation.description" 
              :projectName="project.title" 
              :projectDescription="project.description"
            />
          </div>
      </div>

    </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';
import { EventBus } from "@/event-bus.js";
import ExportBtns from './ExportBtns.vue';
import Grafik from './Grafik.vue';
// import SaveBtn from './SaveBtn.vue';
import tooltip from './tooltip.vue';
import lightbox from './lightbox.vue';
import resetBtn from './resetBtn.vue';
import selectCreatorProfile from './selectCreatorProfile.vue';


export default {
  name: 'Eingabe',
  data() {
    return {

      job: {},
      project: {},
      calculation: {},
      creator_profiles: [],


      //TESTING
      translate_sentence_1: '',


      editGeneralSettings: false,
      generalSettingsValidated: true,
      not_filled_calcName: false,
      not_filled_deckendicke: false,
      not_filled_brandschutzklasse: false,
      not_filled_statSystem: false,
      not_filled_dbewehrungslage: false,

      showFireSafetyInfo: false,
      fireSafetyOptimizing: true,
      showOptimizingInfo: false,


      hohlkoerperBtnAppear: false,
      activePanel: 1,
      showGraphic: false,
      debug: false,
      projects_id: 0,
      calculationid: 0,
      calculationName: '',
      inputHash: '',
      inputParams: {
        in_creators_id: 0,
        in_fireSafetyRequired: true,
        in_deckendicke: 0,
        in_baustoff: 'Ortbeton',
        in_dickeHalbfertigteil: 0,
        in_betondeckungOben: 0,
        in_betondeckungUnten: 0,
        in_bewehrungOben: 0,
        in_bewehrungUnten: 0,
        in_dbewehrungslageUnten: "",
        in_querbewehrung: 0,
        in_leitungsfuehrungOben: false,
        in_leitungsfuehrungUnten: false,
        in_zwlObenHoehe: 0,
        in_zwlUntenHoehe: 0,
        in_betonfestigkeitsklasse: 'C 30/37',
        in_wichte: 25.00,
        in_statNutzhoehe: 0,
        in_multiplyDeckendicke: true,
        in_einbindetiefe: 0,
        in_freieEinbindetiefe: false,
        in_fugenbeschaffenheit: 'glatt',
        in_vnMassivbereich: false,
        in_vorhQuerkraft: 0,
        in_hohlkoerpersystem: 'Bitte auswählen',
        in_sl_unterstuetzungshoehe: 0,
        in_biegezugbewehrung: 0,
        in_brandschutz: 'gemaeß ABZ',
        in_brandschutzklasse: '',
        in_statSystem: '',
        in_cls_onlyFittingTypes: "",
        in_sl_onlyFittingTypes: "",
        in_verwNorm: 'EC2 (DE)',	

        // in_check_geometryPlausible: true,
        // in_check_transverseForceCalculated: true,
      },
      outputParams: {
        out_hoeheHohlkoeprersystem: 0,
        out_verhaeltnisMDMRD: 0,
        out_achsabstand: 0,
        out_ueberdeckung: 0,
        out_achsabstand0: 0,
        out_ueberdeckung0: 0,
        out_achsabstandA: 0,
        out_ueberdeckungA: 0,
        out_achsabstandB: 0,
        out_ueberdeckungB: 0,
        out_achsabstandC: 0,
        out_ueberdeckungC: 0,
        out_querkraftfaktor: 0,
        out_checkNachweis: false,
        out_correctAchsabstand: 0,
        out_correctUeberdeckung: 0,
        out_eigengewicht: 0,
        out_lastreduktion: 0,
        out_querkrafttragfaehigkeitCobiax: 0,
        out_steifigkeitsfaktor: 0,
        out_info6: 6,
        out_info7: 7,
        out_info8: 8,
        out_info9: 9,
        out_info10: 10,
        out_deckendicke: 0,
        out_sollAhk: 0,
        out_deltaAhk: 0,
        out_sollD2Hk: 0,
        out_deltaD2Hk: 0,
        out_sollMinAhk: 0,
        out_sollMinD2Hk: 0,
        out_deltaMinAhk: 0,
        out_deltaMinD2Hk: 0,

        out_optimierungen: [],
        out_fallbackValues: {
          d2hk: 0,
          ahk: 0
        },
        out_workinValues: {
          d2hk: 0,
          ahk: 0
        },

      },
      openTable: false,
      sl_onlyFittingTypes: false,
      cls_onlyFittingTypes: false,
      project_selection: [],
      sl_system_collection: [

      ],
      cls_system_collection: [

      ],
      selected_system: {
        id: '',
        name: '',
        status: '',
        unterstuetzungshoehe: 0,
        zusUnterstuetzungshoehe: 0,
        minDeckendicke: 0,
        maxDeckendicke: 0,
        hinweis: '',
        minSpiegeldickeZumHohlraum: 0
      },
      chosen_system_translated: '',
      chosen_system:{
        id: '',
        name: '',
        status: '',
        unterstuetzungshoehe: 0,
        zusUnterstuetzungshoehe: 0,
        minDeckendicke: 0,
        maxDeckendicke: 0,
        hinweis: '',
        minSpiegeldickeZumHohlraum: 0,
        hohlraumhoehe: 0,
      },
      
      activeSystem: '',
      selected_project: 0,


      //tooltips
      tooltipBewehrungOben: false,
      tooltipBewehrungUnten: false,
      tooltipQuerkraftfaktor: false,
      tooltipBiegezugbewehrung: false,
      tooltipZwlO: false,
      tooltipZwlU: false,
      tooltipVerFuGlatt: false,
      tooltipVerFuRau: false,
      tooltipQuerbewehrung: false,


      warningDeckendicke: false,
      alertMessages_SkipNoneGeometric: false,
      alertMessages: [],

      deckendickeLimit: '',


      // Login Daten
      userdata: {},
      session: {},
      loginStatus: false,


      // Request Spooler
      requestLocked: false,

      brandschutzCode: '',

      productsLoaded: false,

      countries_list: [],

      firesafetyVar: 'zweiachsig |_y/|_x <= 1,5',
      firesafetyVar2: 'zweiachsig 1,5 <= y/x <= 2,0'

    }
  },
  created() {
    axios.get(process.env.VUE_APP_APIENDPOINT + "/public-api/get-countries/json").then(response => (this.countries_list = response.data));
    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      
      //console.log('Eingabe.vue recieved Event: "loginSuccessfulSubComponents"!');
      this.userdata = payload.userdata;
      this.session = payload.session;
      this.loginStatus = true;
      // Projekte laden zum passenden Benutzer
      //this.loadProjectSettingsList();
      this.loadProductsList();
      this.loadCalculationHead();
      this.loadCreatorProfiles();
    });
    EventBus.$on('collectDataForResultPDF-Step03', () => {
      EventBus.$emit('collectDataForResultPDF-Step04', {
        "projects_id": this.projects_id
      });
    });
    EventBus.$on('openCalcSettings', () => {
      this.editGeneralSettings = true
    });
    EventBus.$on('reset_Geometry', () => {
      this.resetGeometry();
    });
    EventBus.$on('reset_interLayer', () => {
      this.resetZwischenlage();
    });
    EventBus.$on('reset_Vorwerte', () => {
      this.resetVorwerte();
    });
    EventBus.$on('reset_bbw', () => {
      this.inputParams.in_biegezugbewehrung = 0;
    });
    EventBus.$on('reset_HK', () => {
      this.resetHK()
    });
    EventBus.$on('load_creator_profiles', () => {
      this.loadCreatorProfiles();
    });
    EventBus.$on('send_creator_profile_id', (payload) => {
      this.inputParams.in_creators_id = payload.id;
    });
    EventBus.$on('reset_creator_profile_id', () => {
      this.inputParams.in_creators_id = 0;
    });
    EventBus.$on('call_recalculate_stiffness', () => {
      console.log('call recalculate stiffness received')
      this.recalculateStiffness();
    });
    this.inputCheck();
  }, 
  mounted() {
    // console.log('openEditModal:')
    // console.log(this.calculation.openEditModal)
    if(this.calculation.openEditModal == true){
      this.editGeneralSettings = true;
    }
  },

  components: {
    'grafik' : Grafik,
    'pdf-export-buttons' : ExportBtns,
    // 'savebtn' : SaveBtn
    'tooltip': tooltip,
    'lightbox': lightbox,
    'reset-btn': resetBtn,
    'select-creator-profile-lightbox': selectCreatorProfile
   },
  watch:{


    'activeSystem'(newValue, oldValue){
      if(newValue != oldValue) {
        
        this.selected_system.name = '';
        this.selected_system.status = '';
        this.selected_system.unterstuetzungshoehe = '';
        this.selected_system.zusUnterstuetzungshoehe
        this.selected_system.minDeckendicke = '';
        this.selected_system.maxDeckendicke = '';
        this.selected_system.hinweis = '';
      }
    },
    'chosen_system.name'(newValue){
        if(newValue.startsWith('CLS')){
          this.inputParams.in_sl_unterstuetzungshoehe = '0';
        }
    },
    'chosen_system'(newValue, oldValue){
      if(newValue != oldValue){
        this.recalculateStiffness();
      }
    },
    'activePanel'(newValue, oldValue){
      if(newValue != oldValue){
        this.recalculateStiffness();
      }
    },
    'inputParams.in_dickeHalbfertigteil'(newValue, oldValue){
      if(newValue != oldValue) {
          EventBus.$emit('update_dickeHalbfertigteil', {
                'load_dickeHalbfertigteil': this.inputParams.in_dickeHalbfertigteil
            });
           this.recalculateStiffness('in_dickeHalbfertigteil',newValue);
        }
    },
    'inputParams.in_baustoff'(newValue, oldValue){
      if(newValue != oldValue) {
          if(newValue == 'Halbfertigteil'){
            this.activeSystem = 'sl';
          }
        }
    },
    'inputParams.in_betondeckungOben'(newValue, oldValue){
      if(newValue != oldValue) {

          EventBus.$emit('update_betondeckungOben', {
                'load_betondeckungOben': this.inputParams.in_betondeckungOben
            });    
           this.recalculateStiffness('in_betondeckungOben',newValue);
        }
    },
    'inputParams.in_betondeckungUnten'(newValue, oldValue){
      if(newValue != oldValue) {
          EventBus.$emit('update_betondeckungUnten', {
                'load_betondeckungUnten': this.inputParams.in_betondeckungUnten
            });
           this.recalculateStiffness('in_betondeckungUnten',newValue);  
        }
    },
    'inputParams.in_bewehrungOben'(newValue, oldValue){
      if(newValue != oldValue) {
          EventBus.$emit('update_bewehrungOben', {
                'load_bewehrungOben': this.inputParams.in_bewehrungOben
            });
            this.recalculateStiffness('in_bewehrungOben',newValue);  
        }
    },
    'inputParams.in_bewehrungUnten'(newValue, oldValue){
      if(newValue != oldValue) {
          EventBus.$emit('update_bewehrungUnten', {
                'load_bewehrungUnten': this.inputParams.in_bewehrungUnten
            });
            this.recalculateStiffness('in_bewehrungUnten',newValue);  
        }
    },
    'inputParams.in_querbewehrung'(newValue, oldValue){
      if(newValue != oldValue) {
          
          this.recalculateStiffness('in_querbewehrung',newValue);  
        }
    },
    'inputParams.in_zwlObenHoehe'(newValue, oldValue){
      if(newValue != oldValue) {
          
          EventBus.$emit('update_zwischenlageOben', {
                'load_zwischenlageOben': this.inputParams.in_zwlObenHoehe
            });
          this.recalculateStiffness('in_zwlObenHoehe',newValue);  
        }
    },
    'inputParams.in_zwlUntenHoehe'(newValue, oldValue){
      if(newValue != oldValue) {
          
          EventBus.$emit('update_zwischenlageUnten', {
                'load_zwischenlageUnten': this.inputParams.in_zwlUntenHoehe
            });
          this.recalculateStiffness('in_zwlUntenHoehe',newValue);  
        }
    },
    'inputParams.in_betonfestigkeitsklasse'(newValue, oldValue){
      if(newValue != oldValue) {
          
          this.recalculateStiffness('in_betonfestigkeitsklasse',newValue);  
        }
    },
    'inputParams.in_wichte'(newValue, oldValue){
      if(newValue != oldValue) {
          
          this.recalculateStiffness('in_wichte',newValue);  
        }
    },
    'inputParams.in_statNutzhoehe'(newValue, oldValue){
      if(newValue != oldValue) {
          
          this.recalculateStiffness('in_statNutzhoehe',newValue);  
        }
    },
    'inputParams.in_multiplyDeckendicke'(newValue, oldValue){
      if(newValue != oldValue) {
          
          this.recalculateStiffness('in_multiplyDeckendicke',newValue);  
        }
    },
    'inputParams.in_einbindetiefe'(newValue, oldValue){
      if(newValue != oldValue) {
          
          this.recalculateStiffness('in_einbindetiefe',newValue);  
        }
    },
    'inputParams.in_freieEinbindetiefe'(newValue, oldValue){
      if(newValue != oldValue) {
          
          this.recalculateStiffness('in_freieEinbindetiefe',newValue);  
        }
    },
    'inputParams.in_fugenbeschaffenheit'(newValue, oldValue){
      if(newValue != oldValue) {
          
          this.recalculateStiffness('in_fugenbeschaffenheit',newValue);  
        }
    },
    'inputParams.in_vnMassivbereich'(newValue, oldValue){
      if(newValue != oldValue) {
          
          
          this.recalculateStiffness('in_vnMassivbereich',newValue);  
        }
    },
    'inputParams.in_vorhQuerkraft'(newValue, oldValue){
      if(newValue != oldValue) {
          
          
          this.recalculateStiffness('in_vorhQuerkraft',newValue);  
        }
    },
    'outputparams.out_hoeheHohlkoeprersystem'(newValue, oldValue){
      if(newValue != oldValue) {
          EventBus.$emit('update_hoeheHohlkoerpersystem', {
                'load_hoeheHohlkoerpersystem': this.outputparams.out_hoeheHohlkoeprersystem
            });

        }
    },
    'inputParams.in_hohlkoerpersystem'(newValue, oldValue){
      if(newValue != oldValue) {
          EventBus.$emit('update_hohlkoerpersystem', {
                'load_hohlkoerpersystem': this.inputParams.in_hohlkoerpersystem
            });
            this.recalculateStiffness('in_hohlkoerpersystem',newValue);  
        }
    },
    'inputParams.in_sl_unterstuetzungshoehe'(newValue, oldValue){
      if(newValue != oldValue) {
          
          this.recalculateStiffness('in_sl_unterstuetzungshoehe',newValue);  
        }
    },
    'inputParams.in_biegezugbewehrung'(newValue, oldValue){
      if(newValue != oldValue) {
          
          this.recalculateStiffness('in_biegezugbewehrung',newValue);  
        }
    },
    'inputParams.in_deckendicke'(newValue, oldValue){
      if(newValue != oldValue && this.chosen_system.name !== '') {
          this.resetHK();
        }
    },
    'inputParams.in_leitungsfuehrungOben'(newValue){
      if(newValue == true) {
        this.inputParams.in_multiplyDeckendicke = true
      }
    },
    'inputParams.in_leitungsfuehrungUnten'(newValue){
      if(newValue == true) {
        this.inputParams.in_multiplyDeckendicke = true
      }
    },

  },
  computed:{
    descStrLength(){
      if(this.calculation.description !== null){
      return this.calculation.description.length;
      }
      else return 0;
    },
    // formatted Inputs
    f_Dd(){
      var v = this.inputParams.in_deckendicke.toString().replace(",",".")
      return Number(v); 
    },
    r_Dd(){
      var numb = +this.f_Dd.toFixed(3)
      return numb
    },
    f_bdO(){
      var v = this.inputParams.in_betondeckungOben.toString().replace(",",".")
      return Number(v); 
    },
    f_bdU(){
      var v = this.inputParams.in_betondeckungUnten.toString().replace(",",".")
      return Number(v); 
    },
    f_bewO(){
      var v = this.inputParams.in_bewehrungOben.toString().replace(",",".")
      return Number(v); 
    },
    f_bewU(){
      var v = this.inputParams.in_bewehrungUnten.toString().replace(",",".")
      return Number(v); 
    },
    f_QB(){
      var v = this.inputParams.in_querbewehrung.toString().replace(",",".")
      return Number(v); 
    },
    f_DHFT(){
      var v = this.inputParams.in_dickeHalbfertigteil.toString().replace(",",".")
      return Number(v); 
    },
    f_zwlO(){
      var v = this.inputParams.in_zwlObenHoehe.toString().replace(",",".")
      return Number(v); 
    },
    f_zwlU(){
      var v = this.inputParams.in_zwlUntenHoehe.toString().replace(",",".")
      return Number(v); 
    },
    f_W(){
      var v = this.inputParams.in_wichte.toString().replace(",",".")
      return Number(v); 
    },
    f_SNh(){
      var v = this.inputParams.in_statNutzhoehe.toString().replace(",",".")
      return Number(v); 
    },
    f_Bbw(){
      var v = this.inputParams.in_biegezugbewehrung.toString().replace(",",".")
      return Number(v); 
    },
    


    // abstandHFTzuHK(){
    //   return (this.f_QB + this.f_zwlU + ( (Number(this.sl_system_collection[0].unterstuetzungshoehe) - Number(this.sl_system_collection[0].hohlraumhoehe)) / 2) + (Number(this.inputParams.in_sl_unterstuetzungshoehe)/10))
    // },




    differenzDeckendicke: function (){
      return this.f_Dd - this.f_zwlO - this.f_zwlU - this.f_bdO - (this.inputParams.in_baustoff == 'Ortbeton' ? this.f_bdU : 0) - this.f_bewO - (this.inputParams.in_baustoff == 'Ortbeton' ? this.f_bewU : 0) - Number(this.chosen_system.unterstuetzungshoehe) - (this.chosen_system.name.startsWith('SL') ? (Number(this.inputParams.in_sl_unterstuetzungshoehe)/10) : 0) - (this.inputParams.in_baustoff == 'Halbfertigteil' ? this.f_DHFT : 0) - (this.inputParams.in_baustoff == 'Halbfertigteil' ? this.f_QB : 0)
    },
    r_differenzDeckendicke(){
      var numb = +this.differenzDeckendicke.toFixed(3)
      return numb 
    },
    usedDeckendicke: function (){
      return this.f_zwlO + this.f_zwlU + this.f_bdO + (this.inputParams.in_baustoff == 'Ortbeton' ? this.f_bdU : 0) + this.f_bewO + (this.inputParams.in_baustoff == 'Ortbeton' ? this.f_bewU : 0) + Number(this.chosen_system.unterstuetzungshoehe) + (this.chosen_system.name.startsWith('SL') ? (Number(this.inputParams.in_sl_unterstuetzungshoehe)/10) : 0) + (this.inputParams.in_baustoff == 'Halbfertigteil' ? this.f_DHFT : 0) + (this.inputParams.in_baustoff == 'Halbfertigteil' ? this.f_QB : 0)
    },
    r_usedDeckendicke(){
      var numb = +this.usedDeckendicke.toFixed(3)
      return numb 
    },
    cablerun_reduced_ceiling(){
      var numb = this.f_Dd - (this.inputParams.in_leitungsfuehrungOben == true ? 2.5 : 0) - (this.inputParams.in_leitungsfuehrungUnten == true ? 2.5 : 0)
      return numb
    },
    filledGeometry: function (){
      let checkFill = false

      if(this.inputParams.in_baustoff == 'Ortbeton'){
        if(
          this.f_bdO > 0 
          && this.f_bewO > 0
          && this.f_bewU > 0
          && this.f_bdU > 0
        ){
          checkFill = true
          return checkFill
        }
      }

      if(this.inputParams.in_baustoff == 'Halbfertigteil'){
        if(
          this.f_bdO > 0
          && this.f_bewO > 0
          && this.f_QB > 0
          && this.f_DHFT > 0
          && this.f_bdU > 0
        ){
          checkFill = true
          return checkFill
        }
      }

      return checkFill

    },

    brandschutz_achsabstand_too_small: function (){
      if(this.outputParams.out_ueberdeckung > 0 && this.outputParams.out_sollD2Hk == 0 && this.outputParams.out_sollMinD2Hk == 0 && this.outputParams.out_achsabstand < this.outputParams.out_sollAhk){
        return true
      }else{
        return false
      }
    },
  },
  methods: {
    createCreatorProfile(){
      EventBus.$emit('open_creatorProfiles');
      EventBus.$emit('open_addCreatorProfileModal');
    },
    EBusEmit(command){
      console.log('emitting EventBus: ' + command)
      EventBus.$emit(command);
    },
    loadCreatorProfiles(){
      //console.log('Loading Creator Profiles...')
        let url = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/creators-list/json';
        let currentObj = this;
        axios.post(url, currentObj.session)
        .then(response => {
          //console.log('Load Creator-Profiles')
          //console.log(response.data.creators)
          currentObj.creator_profiles = response.data.creators;
        })
        .catch(function () {
          //console.log('catch Function of AJAX-Called... userprofileError()');
        });
    },
    updateGeneralSettings(){
      // console.log('updateGeneralSettings.called()');
      this.generalSettingsValidated = true

      if(this.calculation.name == ''){
        this.generalSettingsValidated = false; 
        this.not_filled_calcName = true;
      }
      if(this.inputParams.in_deckendicke == 0){
        this.generalSettingsValidated = false; 
        this.not_filled_deckendicke = true;
      }
      if(this.inputParams.in_brandschutzklasse == '' && this.inputParams.in_fireSafetyRequired == true){
        this.generalSettingsValidated = false; 
        this.not_filled_brandschutzklasse = true;
      }
      if(this.inputParams.in_statSystem == '' && this.inputParams.in_fireSafetyRequired == true){
        this.generalSettingsValidated = false; 
        this.not_filled_statSystem = true;
      }
      if(this.inputParams.in_dbewehrungslageUnten== '' && this.inputParams.in_fireSafetyRequired == true){
        this.generalSettingsValidated = false; 
        this.not_filled_dbewehrungslage = true;
      }

      if(this.generalSettingsValidated == true){

        this.editGeneralSettings = false; 
        this.calculation.openEditModal = false;

        let url = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/calculation-actions/update/json';

        let currentObj = this;
        let data = {};
        data.calculationid = this.$route.params.calculationid;
        data.name = this.calculation.name;
        data.description = this.calculation.description;


        let merged = {...data, ...this.session};
        axios.post(url, merged)
          .then(response => {
            this.recalculateStiffness();
            //Stuff happening
            response.test = 1;
          
        }).catch(function () { currentObj.log('catch Function of AJAX-Called... error()');  });
      }
    },
    loadCalculationHead() {
      let url = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/calculation-actions/load/json';

      let currentObj = this;
      let data = {};
      data.calculationid = this.$route.params.calculationid;

      let merged = {...data, ...this.session};
      this.on
      axios.post(url, merged)
        .then(response => {
         currentObj.job = response.data.job;
         currentObj.project = response.data.project;
         currentObj.calculation = response.data.calc;
         currentObj.calculationid = response.data.calc.id;
         if(response.data.inputParams != null) {
          currentObj.inputParams = response.data.inputParams;
          if(response.data.inputParams.in_hohlkoerpersystem !="") {
            this.checkHohlKoerperWiederHerstellung();
          }
         }
      }).catch(function () { currentObj.log('catch Function of AJAX-Called... error()');  });
    },
    inputCheck: function(){      
         this.intervalid1 = setInterval(function(){
            //console.log('input Check Interval.... called()');
            if(this.inputHash != '') {
              //console.log('Checker: Awaited hash: ' + this.inputHash);
              var proof = window.MD5(JSON.stringify(this.inputParams));
              if(proof != this.inputHash) {
                //console.log('Recalc needed!');
                this.recalculateStiffness();
              }
            }
           
        }.bind(this), 1000);

    },
    checkFireSafetyNorm(){
      if(this.inputParams.in_verwNorm == 'EC2 (DE)'){
        this.inputParams.in_brandschutz = 'gemaeß ABZ'
      }
      if(this.inputParams.in_verwNorm == 'EC2'){
        this.inputParams.in_brandschutz = 'gemaeß Gutachten'
      }
    },
    switchPanel(n){
      this.activePanel = this.activePanel + n
      if(this.activePanel < 1){
        this.activePanel = 1
      }
      if(this.activePanel > 3){
        this.activePanel = 3
      }
    },
    resetGeometry(){
      this.inputParams.in_dickeHalbfertigteil = 0;
      this.inputParams.in_betondeckungOben = 0;
      this.inputParams.in_betondeckungUnten = 0;
      this.inputParams.in_bewehrungOben = 0;
      this.inputParams.in_bewehrungUnten = 0;
      this.inputParams.in_querbewehrung = 0;
      //console.log('Geometry Inputs Reset.')
    },
    resetZwischenlage(){
      this.inputParams.in_zwlObenHoehe = 0;
      this.inputParams.in_zwlUntenHoehe = 0;
      this.inputParams.in_leitungsfuehrungOben = false,
      this.inputParams.in_leitungsfuehrungUnten = false
      // console.log('Zwischenlage Inputs Reset.')
    },
    resetBrandschutz(){
      this.inputParams.in_brandschutz = "gemaeß ABZ"
      this.inputParams.in_brandschutzklasse = "";
      this.inputParams.in_statSystem = "";
      this.inputParams.in_dbewehrungslageUnten = "";
      //console.log('Brandschutz Inputs Reset.')
    },
    resetVorwerte(){
      this.inputParams.in_betonfestigkeitsklasse = "C 30/37";
      this.inputParams.in_wichte = 25;
      this.inputParams.in_statNutzhoehe = 0;
      this.inputParams.in_multiplyDeckendicke = true;
      //console.log('Vorwerte zur Bemessung Inputs Reset.')
    },
    resetVerbundfuge(){
      this.inputParams.in_fugenbeschaffenheit = "";
      this.inputParams.in_vnMassivbereich = false;
      this.inputParams.in_vorhQuerkraft = 0;
      //console.log('Nachweis der Verbudnfuge Inputs Reset.')
    },
    resetHK(){
        this.chosen_system.id = '';
        this.chosen_system.name = '';
        this.chosen_system.status = '';
        this.chosen_system.unterstuetzungshoehe = 0;
        this.chosen_system.zusUnterstuetzungshoehe = 0;
        this.chosen_system.minDeckendicke = 0;
        this.chosen_system.maxDeckendicke = 0;
        this.chosen_system.hinweis = '';
        this.chosen_system.minSpiegeldickeZumHohlraum = 0;
        this.chosen_system.hohlraumhoehe = 0;
        this.inputParams.in_sl_unterstuetzungshoehe = 0;
    },
    toggleVnMassivbereich(){
      if(this.inputParams.in_vnMassivbereich == true){
        this.inputParams.in_fugenbeschaffenheit = 'rau'
      }
    },
    select_system(system){
      // console.log(system)
      var s = system
      this.selected_system.id = s.id
      this.selected_system.name = s.name
      this.selected_system.status = s.status
      this.selected_system.unterstuetzungshoehe = Number(s.unterstuetzungshoehe) 
      this.selected_system.hohlraumhoehe = Number(s.hohlraumhoehe)
      this.selected_system.minDeckendicke = Number(s.minDeckendicke)
      this.selected_system.zusatzbemerkung = s.zusatzbemerkung
      this.selected_system.maxDeckendicke = Number(s.maxDeckendicke)
      this.selected_system.minSpiegeldickeZumHohlraum = Number(s.minSpiegeldickeZumHohlraum)
      this.selected_system.hinweis = s.hinweis

    },
    chooseSystem(){
      console.log('Choosing HK System...')
      this.chosen_system.id = this.selected_system.id;
      this.chosen_system.name = this.selected_system.name;
      this.chosen_system.status = this.selected_system.status;
      this.chosen_system.unterstuetzungshoehe = this.selected_system.unterstuetzungshoehe;
      this.chosen_system.hohlraumhoehe = this.selected_system.hohlraumhoehe;
      this.chosen_system.minDeckendicke = this.selected_system.minDeckendicke;
      this.chosen_system.maxDeckendicke = this.selected_system.maxDeckendicke;
      this.chosen_system.zusatzbemerkung = this.selected_system.zusatzbemerkung;
      this.chosen_system.minSpiegeldickeZumHohlraum = this.selected_system.minSpiegeldickeZumHohlraum;
      this.chosen_system.hinweis = this.selected_system.hinweis;
      this.chosen_system_translated = this.selected_system.name;
      this.inputParams.in_hohlkoerpersystem = this.selected_system.name;

      // this.checkDeckendickeMinMax();
      EventBus.$emit('update_hohlkoerper', {
                'load_name': this.chosen_system.name,
                'load_unterstuetzungshoehe': this.chosen_system.unterstuetzungshoehe,
            });
      this.recalculateStiffness();
    },
    checkProdukteingrenzungundFugen() {
      if(this.inputParams.in_baustoff == 'Ortbeton') {
        this.inputParams.in_fugenbeschaffenheit = 'glatt';

        this.inputParams.in_dickeHalbfertigteil = 0;
        this.inputParams.in_querbewehrung = 0;
      }
      if(this.inputParams.in_baustoff == 'Halbfertigteil') {
        this.inputParams.in_fugenbeschaffenheit = 'rau';

        // Wenn Halbfertigteil, dann darf kein CLS benutzt werden
        if(this.chosen_system.name.startsWith('CLS')) {
          this.activeSystem = 'sl';
          this.inputParams.in_hohlkoerpersystem = '';

          this.chosen_system.id = '';
          this.chosen_system.name = '';
          this.chosen_system.status = '';
          this.chosen_system.unterstuetzungshoehe = 0;
          this.chosen_system.hohlraumhoehe = 0;
          this.chosen_system.minDeckendicke = 0;
          this.chosen_system.maxDeckendicke = 0;
          this.chosen_system.minSpiegeldickeZumHohlraum = 0;
          this.chosen_system.hinweis = '';
          this.chosen_system_translated = '';

          this.alertMessages.push = this.$t('alertmessages_04');
        }
        this.inputParams.in_bewehrungUnten = 0;

      }
    },
    checkPanelNumber(){
      if(this.activePanel == 3 && this.inputParams.in_fireSafetyRequired == false){
        this.activePanel = 2;
      }
    },
    checkHohlKoerperWiederHerstellung() {
      let currentObj = this;
        if(this.inputParams.in_hohlkoerpersystem != "") {
          console.log('Checking HK Wiederherst.: this.inputParams.in_hohlkoerpersystem ist nicht leer!');
          if(!this.isEmpty(this.chosen_system)) {
            console.log('Checking HK Wiederherst.: this.isEmpty(this.chosen_system) ist gesetzt und nicht leer!');
            
            console.log('Checking HK Wiederherst.: this.chosen_system.name: "'+ this.chosen_system.name + '"');
            if(this.chosen_system.name == "") {
              console.log('Checking HK Wiederherst.: Fehler bei in_hohlkoerpersystem-wiederherstellung');
              let typ = this.inputParams.in_hohlkoerpersystem.substr(0,2);
                console.log('Checking HK Wiederherst.:this.inputParams.in_hohlkoerpersystem:' + this.inputParams.in_hohlkoerpersystem);
              console.log('Checking HK Wiederherst.:typ:' + typ);
              if(typ == "CL") {
                for (let i = 0; i < this.cls_system_collection.length; i++) {
                  console.log('Checking HK Wiederherst.:cehcking: ' + this.cls_system_collection[i].name);
                  if(this.cls_system_collection[i].name == this.inputParams.in_hohlkoerpersystem) {
                      console.log('Checking HK Wiederherst.: Setze Hohlkörper auf: ' + this.inputParams.in_hohlkoerpersystem);
                      this.select_system(this.cls_system_collection[i]);
                      this.chooseSystem();
                      setTimeout(function (){
                         currentObj.recalculateStiffness();
                      },1000);
                      
                     
                  } 
                }
              }
              if(typ == "SL") {
                for (let i = 0; i < this.sl_system_collection.length; i++) {
                  if(this.sl_system_collection[i].name == this.inputParams.in_hohlkoerpersystem) {
                      console.log('Checking HK Wiederherst.: Setze Hohlkörper auf: ' + this.inputParams.in_hohlkoerpersystem);
                      this.select_system(this.sl_system_collection[i]);
                      this.chooseSystem();
                      setTimeout(function (){
                         currentObj.recalculateStiffness();
                      },1000);
                  }
                }
              }

            }
          }
        }
    },
    loadProductsList() {
      if(!this.productsLoaded ) {
        let url = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/product-list-splitted/json';
        axios.post(url, this.session)
            .then(response => {
              this.cls_system_collection = response.data.products_cls;
              this.sl_system_collection = response.data.products_sl;
              this.recalculateProducts();
              this.productsLoaded = true;
              this.checkHohlKoerperWiederHerstellung();

              

            })
            .catch(function () {
              this.log('catch Function of AJAX-Called... error()');
            });
      } else {
        this.recalculateProducts();
      }
    },
    log: function (obj) {
      if(this.debug) {
        this.log(obj)
      }
    },

    dummySave(){
      this.recalculateStiffness()
      this.alertMessages.push(
              {
                id: (this.alertMessages.length +1),
                text: this.$t('alertmessages_02'),
                importance: 'info'
              }
      );
    },
     recalculateProducts() {
      // console.log('recalculateProducts.called()');

    
        // var aktuelleUnterstuezungshoehe = 0.0;
        // // h - (cnom,o + hbew,o + ci,o + cnom,u + hbew,u + ci,u) (lastenheft: seite )
        // aktuelleUnterstuezungshoehe = parseFloat(this.inputParams.in_deckendicke) - (
        //   parseFloat(this.inputParams.in_betondeckungOben) + 
        //   parseFloat(this.inputParams.in_betondeckungUnten) + 
        //   parseFloat(this.inputParams.in_bewehrungOben) +
        //   parseFloat(this.inputParams.in_bewehrungUnten) +
        //   parseFloat(this.inputParams.in_zwlObenHoehe) + 
        //   parseFloat(this.inputParams.in_zwlUntenHoehe)
        // )

        
        for (let i = 0; i < this.cls_system_collection.length; i++) {
            if(
              this.f_Dd >= parseFloat(this.cls_system_collection[i].minDeckendicke) &&
              this.f_Dd <= parseFloat(this.cls_system_collection[i].maxDeckendicke) &&
              (this.r_differenzDeckendicke + (this.chosen_system.name.startsWith('SL') ? this.chosen_system.unterstuetzungshoehe + (Number(this.inputParams.in_sl_unterstuetzungshoehe)/10) : this.chosen_system.unterstuetzungshoehe)) >= this.cls_system_collection[i].unterstuetzungshoehe
            ) {
              this.cls_system_collection[i].status = 'usable'; 
              this.cls_system_collection[i].hinweis = 'ok-ceilingheight-ranges-fit'; 
            } else {
              this.cls_system_collection[i].status = 'not-usable'; 
              this.cls_system_collection[i].hinweis = 'no-ceilingheight-ranges-do-not-fit'; 
            }

            // if(this.cls_system_collection[i].status == 'usable') {
            //   // Unterstützungshoehe prüfen
            //   if(aktuelleUnterstuezungshoehe <= parseFloat(this.cls_system_collection[i].unterstuetzungshoehe))
            //   {
            //     this.cls_system_collection[i].status = 'not-usable'; 
            //     this.cls_system_collection[i].hinweis = 'unterstuetzungshoehe-failure'; 
            //   }
            // }
            
        }
         for (let i = 0; i < this.sl_system_collection.length; i++) {
            if(
              parseFloat(this.inputParams.in_deckendicke) >= parseFloat(this.sl_system_collection[i].minDeckendicke) &&
              parseFloat(this.inputParams.in_deckendicke) <= parseFloat(this.sl_system_collection[i].maxDeckendicke) &&
              (this.r_differenzDeckendicke + Number(this.chosen_system.unterstuetzungshoehe) >= Number(this.sl_system_collection[i].unterstuetzungshoehe) + ( this.chosen_system.name == '' ? Number(this.inputParams.in_sl_unterstuetzungshoehe/10) : 0))
            ) {
              this.sl_system_collection[i].status = 'usable'; 
              this.sl_system_collection[i].hinweis = 'ok-ceilingheight-ranges-fit'; 
              //Passt schon mal rein
                if((

                    (this.f_QB 
                    + this.f_zwlU 
                    + this.r_differenzDeckendicke + Number(this.chosen_system.unterstuetzungshoehe) - Number(this.sl_system_collection[i].unterstuetzungshoehe/2) + ( this.chosen_system.name == '' ? Number(this.inputParams.in_sl_unterstuetzungshoehe/10) : 0))
                    <
                    3) 
                    && this.inputParams.in_baustoff == 'Halbfertigteil' 
                    && (Number(this.sl_system_collection[i].unterstuetzungshoehe) + 2 > this.r_differenzDeckendicke + Number(this.chosen_system.unterstuetzungshoehe))){

                this.sl_system_collection[i].status = 'not-usable'; 
                this.sl_system_collection[i].hinweis = 'no-ceilingheight-ranges-do-not-fit'; 
                } else {
                  this.sl_system_collection[i].status = 'usable'; 
                  this.sl_system_collection[i].hinweis = 'ok-ceilingheight-ranges-fit'; 
                }
            } else {
              this.sl_system_collection[i].status = 'not-usable'; 
              this.sl_system_collection[i].hinweis = 'no-ceilingheight-ranges-do-not-fit'; 
            }

            // if(this.sl_system_collection[i].status == 'usable') {
            //   // Unterstützungshoehe prüfen
            //   if(aktuelleUnterstuezungshoehe <= parseFloat(this.sl_system_collection[i].unterstuetzungshoehe))
            //   {
            //     this.sl_system_collection[i].status = 'not-usable'; 
            //     this.sl_system_collection[i].hinweis = 'unterstuetzungshoehe-failure'; 
            //   }
            // }
            
        }
    },
    checkAlertMessagePriorities() {
      this.alertMessages_SkipNoneGeometric = false;

      var dummyArray = []

      for(let i = 0; i < this.alertMessages.length; i++){
        if(this.alertMessages[i].importance == 'critical'){
          dummyArray.push(this.alertMessages[i])
        }
      }
      for(let x = 0; x < this.alertMessages.length; x++){
        if(this.alertMessages[x].importance == 'nongeometric'){
          dummyArray.push(this.alertMessages[x])
        }
      }
      for(let y = 0; y < this.alertMessages.length; y++){
        if(this.alertMessages[y].importance == 'success'){
          dummyArray.push(this.alertMessages[y])
        }
      }
      for(let z = 0; z < this.alertMessages.length; z++){
        if(this.alertMessages[z].importance == 'info'){
          dummyArray.push(this.alertMessages[z])
        }
      }


      this.alertMessages = dummyArray;
       
    },
    recalculateStiffness(changedKey, newValue) {

      //this.checkHohlKoerperWiederHerstellung(); 
      
      var plausibleCeiling = true;


      //console.log('HOLY RECALCULATESTIFFNESS CALLED')
      if(this.requestLocked == false) {
        this.requestLocked = true;
     
      this.inputHash = window.MD5(JSON.stringify(this.inputParams));
      
      let createURL = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/recalculate/stiffness/json';
      
      let data = {};


      data.changedKey = changedKey;
      data.changeValue = newValue;
      data.inputParams = this.inputParams;

      // TODO CHANGE PROJECT TO CALCULATION! IMPORTANT!
      data.calculationid = this.calculationid;

      this.alertMessages = [];


      // [1] Bitte Hohlkörpersystem auswählen
      if(this.chosen_system.name == ""){
          this.hohlkoerperBtnAppear = false;
          if(this.filledGeometry == true){
            this.hohlkoerperBtnAppear = true;
            this.alertMessages.push(
              {
                id: (this.alertMessages.length +1),
                text: this.$t('alertmessages_03'),
                importance: 'critical'
              }
            );
          }else{
            this.hohlkoerperBtnAppear = false;
          }
      }

      // [10] Bei Halbfertigteil nur SL
      if(this.inputParams.in_baustoff == 'Halbfertigteil' && this.chosen_system.name.startsWith('SL') == false) {
        this.alertMessages.push(
            {
              id: (this.alertMessages.length +1),
              text: this.$t('alertmessages_04'),
              importance: 'info'
            }
        );
      }

      if(this.f_Dd < this.usedDeckendicke) {
        this.alertMessages.push(
            {
              id: (this.alertMessages.length +1),
              text: this.$t('alertmessages_05'),
              importance: 'critical'
            }
        );
      }

      // [14] Grenzquerkraft VRd,c,Cobiax ermittelt
      if(this.outputParams.out_querkrafttragfaehigkeitCobiax !== 0 && this.f_Bbw > 0 && this.chosen_system.name !== '' && this.differenzDeckendicke == 0) {
        this.alertMessages.push(
            {
              id: (this.alertMessages.length +1),
              text: this.$t('alertmessages_06'),
              importance: 'success'
            }
        );
      }



      // [11] Abstand HFT Oberkante und Hohlraum-Unterkante mind. 3cm
      if(this.inputParams.in_baustoff == "Halbfertigteil" && this.chosen_system.name !== '') {
        if((this.f_QB + this.f_zwlU + ( (Number(this.chosen_system.unterstuetzungshoehe) - Number(this.chosen_system.hohlraumhoehe)) / 2) + (this.chosen_system.name.startsWith('SL') ? Number(this.inputParams.in_sl_unterstuetzungshoehe) : 0)) < 3){
        
        this.alertMessages.push(
            {
              id: (this.alertMessages.length +1),
              text: this.$t('alertmessages_07'),
              importance: 'critical'
            }
        );
        plausibleCeiling = false
        }
      }

      // [9] Biegezugbewehrung <= 0
      if (this.f_Bbw <= 0 && this.activePanel == 2) {
          this.alertMessages.push(
            {
              id: (this.alertMessages.length +1),
              text: this.$t('alertmessages_09'),
              importance: 'nongeometric'
            }
        );

      }

      // if (this.inputParams.in_baustoff == 'Halbfertigteil' && this.f_DHFT - this.f_bdU < 0) {
      //     this.alertMessages.push(
      //       {
      //         id: (this.alertMessages.length +1),
      //         text: 'Untere Betondeckung kann nicht größer sein als die Dicke des Halbfertigteils selbst!',
      //         importance: 'critical'
      //       }
      //   );

      // }

      if (this.inputParams.in_baustoff == 'Halbfertigteil' && this.f_DHFT - this.f_bdU < 0.5) {
          this.alertMessages.push(
            {
              id: (this.alertMessages.length +1),
              text: this.$t('alertmessages_10'),
              importance: 'critical'
            }
        );
        plausibleCeiling = false

      }

      if (this.f_W < 21) {
          this.alertMessages.push(
            {
              id: (this.alertMessages.length +1),
              text: this.$t('alertmessages_11'),
              importance: 'nongeometric'
            }
        );

      }

      if(this.chosen_system.name !== '') {
        if(this.inputParams.in_baustoff == 'Halbfertigteil' && this.f_zwlU + this.f_QB + Number(this.chosen_system.unterstuetzungshoehe)/2 + Number(this.inputParams.in_sl_unterstuetzungshoehe)/10 < 3){
          this.alertMessages.push(
              {
                id: (this.alertMessages.length +1),
                text: this.$t('alertmessages_07'),
                importance: 'nongeometric'
              }
          );
          plausibleCeiling = false
        }
      }

      if(this.f_Dd < 21 && this.chosen_system.name.startsWith('CLS') && this.inputParams.in_fireSafetyRequired == true && this.inputParams.in_brandschutz == 'gemaeß ABZ'){
        this.alertMessages.push(
            {
              id: (this.alertMessages.length +1),
              text: this.$t('alertmessages_23'),
              importance: 'critical'
            }
        );
      }

      if(this.f_Dd < 23 && this.chosen_system.name.startsWith('SL') && this.inputParams.in_fireSafetyRequired == true && this.inputParams.in_brandschutz == 'gemaeß ABZ'){
        this.alertMessages.push(
            {
              id: (this.alertMessages.length +1),
              text: this.$t('alertmessages_24'),
              importance: 'critical'
            }
        );
      }

      if(this.inputParams.in_multiplyDeckendicke == false){
          if(this.f_Dd < this.f_SNh){
          this.alertMessages.push(
              {
                id: (this.alertMessages.length +1),
                text: this.$t('alertmessages_25'),
                importance: 'critical'
              }
          );
          plausibleCeiling = false
        }
      }

      let merged = {...data, ...this.session};

       axios.post(createURL, merged)
        .then(response => {
          
          if(response.data.success == true) {

            console.log('recalculateStiffness response data:')
            console.log(response.data)

            // Produktname
            this.chosen_system_translated = response.data.modulname;
            
            if(response.data.stiffness.API_RESPONSE_CODE == "400") {
              console.log('API RESPONSE STIFFNESS = 400. NO CHECKING POSSIBLE')
            }
            // Steifigkeit
            if(response.data.stiffness.API_RESPONSE_CODE == "200") {
              console.log('API RESPONSE STIFFNESS = 200. Checking ALERT MESSAGES')
              this.outputParams.out_steifigkeitsfaktor = response.data.stiffness.OUTPUT.stiffness;

              // [4] Steifigkeitsberechnung SL
              if(this.chosen_system.name.startsWith('SL')  && this.filledGeometry == true){
                if(parseFloat(response.data.stiffness.OUTPUT.deckenDickeCalc) < this.f_Dd && this.differenzDeckendicke > 2) {
                    var diff = this.r_differenzDeckendicke;
                    this.alertMessages.push(
                        {
                          id: (this.alertMessages.length +1),
                          text: this.$t('alertmessages_13_part_1') + this.$options.filters.formatNumber(diff) + this.$t('alertmessages_13_part_2'),
                          importance: 'critical'
                        }
                    );
                }
                if(parseFloat(response.data.stiffness.OUTPUT.deckenDickeCalc) < this.f_Dd && this.differenzDeckendicke <= 2) {
                    var diff3 = this.r_differenzDeckendicke;
                    this.alertMessages.push(
                        {
                          id: (this.alertMessages.length +1),
                          text: this.$t('alertmessages_14_part_1') + this.$options.filters.formatNumber(diff3) + this.$t('alertmessages_14_part_2'),
                          importance: 'critical'
                        }
                    );
                }
              }

              // [5] Steifigkeitsberechnung CLS
              if(this.chosen_system.name.startsWith('CLS')  && this.filledGeometry == true){
                if(parseFloat(response.data.stiffness.OUTPUT.deckenDickeCalc) < this.f_Dd) {
                    var diff2 = this.r_differenzDeckendicke;
                    this.alertMessages.push(
                        {
                          id: (this.alertMessages.length +1),
                          text: this.$t('alertmessages_15_part_1') + this.$options.filters.formatNumber(diff2) + this.$t('alertmessages_15_part_2'),
                          importance: 'nongeometric'
                        }
                    );
                }
              }

              //CQL Reborn: Neue SL_Prüfung zur Spiegeldicke 

              // Mindestspiegeldicke beachten SL
              if(this.chosen_system.name !== '' && this.chosen_system.name.startsWith('SL') && this.filledGeometry == true){
                let sl_minSpiegeldickezumHohlraum = 0
                if(this.f_Dd <= 32){
                  console.log('es greift <= 32')
                  sl_minSpiegeldickezumHohlraum = 6
                }else if(this.f_Dd > 32 && this.f_Dd <= 35){
                  console.log('es greift > 32 && <= 35')
                  sl_minSpiegeldickezumHohlraum = 6.5
                }else if(this.f_Dd > 35){
                  console.log('es greift > 35')
                  sl_minSpiegeldickezumHohlraum = 7
                }
                // [2] Mindestspiegeldicke oben beachten SL
                if(parseFloat(sl_minSpiegeldickezumHohlraum) > (parseFloat(response.data.stiffness.OUTPUT.spiegelDickeO) + (this.differenzDeckendicke >= 0 ? this.differenzDeckendicke : 0))) {
                this.alertMessages.push(
                      {
                        id: (this.alertMessages.length +1),
                        text: this.$t('alertmessages_16_part_1') + this.$options.filters.formatNumber(sl_minSpiegeldickezumHohlraum) + this.$t('alertmessages_16_part_2'),
                        importance: 'critical'
                      }
                  );
                  plausibleCeiling = false
                }
                
                // [3] Mindestspiegeldicke unten beachten
                if(this.sl_minSpiegeldickezumHohlraum < 7 && this.inputParams.in_brandschutz == 'gemaeß ABZ' && this.inputParams.in_fireSafetyRequired == true){
                  //do nothing
                }
                else if(parseFloat(sl_minSpiegeldickezumHohlraum) > parseFloat(response.data.stiffness.OUTPUT.spiegelDickeU)) {
                  this.alertMessages.push(
                      {
                        id: (this.alertMessages.length +1),
                        text: this.$t('alertmessages_17_part_1') + this.$options.filters.formatNumber(sl_minSpiegeldickezumHohlraum) + this.$t('alertmessages_17_part_2'),
                        importance: 'critical'
                      }
                  );
                  plausibleCeiling = false
                }
              }
              // [2] Mindestspiegeldicke oben beachten CLS
              if(this.chosen_system.name !== '' && !this.chosen_system.name.startsWith('SL') && this.filledGeometry == true){
                  if(parseFloat(this.chosen_system.minSpiegeldickeZumHohlraum) > (parseFloat(response.data.stiffness.OUTPUT.spiegelDickeO) + (this.differenzDeckendicke >= 0 ? this.differenzDeckendicke : 0))) {
                  this.alertMessages.push(
                        {
                          id: (this.alertMessages.length +1),
                          text: this.$t('alertmessages_16_part_1') + this.$options.filters.formatNumber(this.chosen_system.minSpiegeldickeZumHohlraum) + this.$t('alertmessages_16_part_2'),
                          importance: 'critical'
                        }
                    );
                    plausibleCeiling = false
                }
              }

              // [3] Mindestspiegeldicke unten beachten
              if(this.chosen_system.name !== '' && !this.chosen_system.name.startsWith('SL') && this.filledGeometry == true){
                if(this.chosen_system.minSpiegeldickeZumHohlraum < 7 && this.inputParams.in_brandschutz == 'gemaeß ABZ' && this.inputParams.in_fireSafetyRequired == true){
                  //do nothing
                }
                else if(parseFloat(this.chosen_system.minSpiegeldickeZumHohlraum) > parseFloat(response.data.stiffness.OUTPUT.spiegelDickeU)) {

                this.alertMessages.push(
                      {
                        id: (this.alertMessages.length +1),
                        text: this.$t('alertmessages_17_part_1') + this.$options.filters.formatNumber(this.chosen_system.minSpiegeldickeZumHohlraum) + this.$t('alertmessages_17_part_2'),
                        importance: 'critical'
                      }
                  );
                  plausibleCeiling = false
                }
              }
            } 
            // else {
            //   if(this.outputParams.out_steifigkeitsfaktor == 0){
            //     this.alertMessages.push(
            //         {
            //           id: (this.alertMessages.length +1),
            //           text: 'Steifigkeit konnte noch nicht berechnet werden, Werte überprüfen!',
            //           importance: 'nongeometric'
            //         }
            //     );
            //   }
            // }

            // Allgemeine Kalkulation
            if(response.data.calc.API_RESPONSE_CODE == "200") {
              this.outputParams.out_querkrafttragfaehigkeitCobiax = response.data.calc.OUTPUT.nachweisQuerkrafttragfaehigkeit.vrdcCobiax;
              this.outputParams.out_querkraftfaktor = response.data.calc.OUTPUT.nachweisQuerkrafttragfaehigkeit.querkraftfaktor;
              this.outputParams.out_lastreduktion = response.data.lastreduktion.OUTPUT.lastreduktion;
              this.outputParams.out_eigengewicht = response.data.calc.OUTPUT.eigenlast;

              

            }
              //console.log(response.data.calc.OUTPUT)
                /*this.alertMessages.push(
                    {
                      id: (this.alertMessages.length +1),
                      text: 'Allgemeine Kalkulation konnte noch nicht berechnet werden, Werte überprüfen!',
                      importance: 'critical'
                    }
                );*/

            // Brandschutz
            if(this.inputParams.in_fireSafetyRequired) {

              // [7] Untere Betondeckung zum Hohlraum muss mindestens 7cm betragen.
              if(parseFloat(this.chosen_system.minSpiegeldickeZumHohlraum) <= (parseFloat(response.data.stiffness.OUTPUT.spiegelDickeO) + (this.differenzDeckendicke >= 0 ? this.differenzDeckendicke : 0)) && this.chosen_system.name !== ''){
                if(this.inputParams.in_brandschutz == 'gemaeß ABZ' && this.chosen_system.minSpiegeldickeZumHohlraum < 7){
                  if(this.inputParams.in_baustoff == 'Ortbeton' && (this.f_bdU + this.f_bewU + this.f_zwlU + ( (Number(this.chosen_system.unterstuetzungshoehe) - Number(this.chosen_system.hohlraumhoehe)) / 2 ) + (this.chosen_system.name.startsWith('SL') ? Number(this.inputParams.in_sl_unterstuetzungshoehe) : 0) ) < 7
                  ){
                    this.alertMessages.push(
                      {
                        id: (this.alertMessages.length +1),
                        text: this.$t('alertmessages_18'),
                        importance: 'critical'
                      }
                    );
                  }
                  if(this.inputParams.in_baustoff == 'Halbfertigteil' && (this.f_bdU + this.f_QB + this.f_DHFT + this.f_zwlU + ( (Number(this.chosen_system.unterstuetzungshoehe) - Number(this.chosen_system.hohlraumhoehe)) / 2 ) + (this.chosen_system.name.startsWith('SL') ? Number(this.inputParams.in_sl_unterstuetzungshoehe) : 0)) < 7
                  ){
                    this.alertMessages.push(
                      {
                        id: (this.alertMessages.length +1),
                        text: this.$t('alertmessages_18'),
                        importance: 'critical'
                      }
                    );
                  }
                }
              }

              if(response.data.brandschutz.API_RESPONSE_CODE == "200") {

                this.outputParams.out_checkNachweis = false

                this.brandschutzCode = '200'

                this.outputParams.out_sollAhk = 0;
                this.outputParams.out_sollD2Hk = 0;
                this.outputParams.out_deltaAhk = 0;
                this.outputParams.out_deltaD2Hk = 0;

                this.outputParams.out_sollMinAhk = 0,
                this.outputParams.out_sollMinD2Hk = 0,
                this.outputParams.out_deltaMinAhk = 0,
                this.outputParams.out_deltaMinD2Hk = 0,

                this.outputParams.out_fallbackValues.d2hk = 0,
                this.outputParams.out_fallbackValues.ahk = 0,

                this.outputParams.out_workinValues.d2hk = 0,
                this.outputParams.out_workinValues.ahk = 0,



                this.outputParams.out_kombination_a_ahk = null,
                this.outputParams.out_kombination_a_d2hk = null,
                this.outputParams.out_kombination_b_ahk = null,
                this.outputParams.out_kombination_b_d2hk = null,
                this.outputParams.out_kombination_c_ahk = null,
                this.outputParams.out_kombination_c_d2hk = null,

                this.outputParams.out_achsabstand =  response.data.brandschutz.OUTPUT.ahk;
                this.outputParams.out_ueberdeckung =  response.data.brandschutz.OUTPUT.d2Hk;
                this.outputParams.out_checkNachweis = response.data.brandschutz.OUTPUT.nachweis_erbracht;
                
                this.outputParams.out_deltaAhk = response.data.brandschutz.OUTPUT.deltaAhk;
                this.outputParams.out_deltaD2Hk = response.data.brandschutz.OUTPUT.deltaD2Hk;
                if(response.data.brandschutz.OUTPUT.sollAhk !== null){
                  this.outputParams.out_sollAhk = response.data.brandschutz.OUTPUT.sollAhk;
                }
                if(response.data.brandschutz.OUTPUT.sollD2Hk !== null){
                  this.outputParams.out_sollD2Hk = response.data.brandschutz.OUTPUT.sollD2Hk;
                }

                this.outputParams.out_deltaMinAhk = response.data.brandschutz.OUTPUT.deltaMinAhk;
                this.outputParams.out_deltaMinD2Hk = response.data.brandschutz.OUTPUT.deltaMinD2Hk;
                if(response.data.brandschutz.OUTPUT.sollMinAhk !== null){
                  this.outputParams.out_sollMinAhk = response.data.brandschutz.OUTPUT.sollMinAhk;
                }
                if(response.data.brandschutz.OUTPUT.sollMinD2Hk !== null){
                  this.outputParams.out_sollMinD2Hk = response.data.brandschutz.OUTPUT.sollMinD2Hk;
                }
                if(response.data.brandschutz.OUTPUT.fallbackValues !== null && response.data.brandschutz.OUTPUT.fallbackValues.d2hk !== undefined){
                  this.outputParams.out_fallbackValues.d2hk = response.data.brandschutz.OUTPUT.fallbackValues.d2hk;
                  this.outputParams.out_fallbackValues.ahk = response.data.brandschutz.OUTPUT.fallbackValues.ahk;
                }
                if(response.data.brandschutz.OUTPUT.workinValues !== null && response.data.brandschutz.OUTPUT.workinValues.d2hk !== undefined){
                  this.outputParams.out_workinValues.d2hk = response.data.brandschutz.OUTPUT.workinValues.d2hk;
                  this.outputParams.out_workinValues.ahk = response.data.brandschutz.OUTPUT.workinValues.ahk;
 
                }
                // if(response.data.brandschutz.OUTPUT.fallbackValues.ahk !== undefined){
                //   this.outputParams.out_fallbackValues.ahk = response.data.brandschutz.OUTPUT.fallbackValues.ahk
                // }

                //Brandschutznachweis noch nicht erbracht
                if(
                  response.data.brandschutz.OUTPUT.nachweis_erbracht == false 
                  && this.inputParams.in_fireSafetyRequired == true
                  && parseFloat(this.chosen_system.minSpiegeldickeZumHohlraum) <= (parseFloat(response.data.stiffness.OUTPUT.spiegelDickeO) + (this.differenzDeckendicke >= 0 ? this.differenzDeckendicke : 0))
                  && parseFloat(this.chosen_system.minSpiegeldickeZumHohlraum) <= parseFloat(response.data.stiffness.OUTPUT.spiegelDickeU)
                  && this.chosen_system.name !== ''
                ) {
                  this.alertMessages.push(
                      {
                        id: (this.alertMessages.length +1),
                        text: this.$t('alertmessages_21'),
                        importance: 'nongeometric'
                      }
                  );
                }

                //Brandschutznachweis erbracht
                if(response.data.brandschutz.OUTPUT.nachweis_erbracht == true && this.inputParams.in_fireSafetyRequired == true && this.chosen_system.name !== '') {
                  this.alertMessages.push(
                      {
                        id: (this.alertMessages.length +1),
                        text: this.$t('alertmessages_22'),
                        importance: 'success'
                      }
                  );
                }
              } else if(response.data.brandschutz.API_RESPONSE_CODE == "400") {
                // console.log('response code 400 brandschutz')

                this.outputParams.out_checkNachweis = false

                this.brandschutzCode = '400'

                this.outputParams.out_sollAhk = 0;
                this.outputParams.out_sollD2Hk = 0;
                this.outputParams.out_deltaAhk = 0;
                this.outputParams.out_deltaD2Hk = 0;
              }
            }

            // [12] Geometriewerte plausibel
            if(this.differenzDeckendicke == 0 && this.chosen_system.name !== '' && this.filledGeometry == true && plausibleCeiling == true && ((this.inputParams.in_fireSafetyRequired == true && this.outputParams.out_checkNachweis == true) || (this.inputParams.in_fireSafetyRequired == false))){
              this.alertMessages.push(
                {
                  id: (this.alertMessages.length +1),
                  text: this.$t('alertmessages_08'),
                  importance: 'success'
                }
              );
            }


            this.checkAlertMessagePriorities();
            
            EventBus.$emit('showDebug', {})

            EventBus.$emit('showDebug', {
                  'debug': response.data
            });

            this.recalculateProducts();
            this.requestLocked = false;
          } else {
            alert(this.$t('session_used_multiple_times'));
            this.$router.push({ path:'/' + this.$i18n.locale + '/logout-session'});
            // window.location.reload();
          }


        })
        .catch(function (error) {
          console.log('recalculate: catch Function of AJAX-Called... error()' + error);
          // console.log(error);
          
        });
        console.log('Checking HK Wiederherst.');
        
      } 
    },
    isEmpty(obj) {
        for(var prop in obj) {
            if(obj.hasOwnProperty(prop))
                return false;
        }

        return JSON.stringify(obj) === JSON.stringify({});
    },
    optimizeFireSafety(){
      //console.log('Optimizing Firesafety called')
      let createURL = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/get-fire-prevention-optimization/json';
      let data = {};
      data.inputParams = this.inputParams;
      data.calculationid = this.calculationid;

      let merged = {...data, ...this.session};

       axios.post(createURL, merged)
        .then(response => {
            //console.log(response.data)

            this.outputParams.out_optimierungen = response.data.optimization.OUTPUT.optimierungen

            //console.log(this.outputParams.out_optimierungen)

        });
        this.EBusEmit('open_fireSafetyOptimizingInfo')
    },
    checkCalculationCloseModal(){
      if(this.calculation.name == ''){
    this.$router.push({ path:'/' + this.$i18n.locale + '/calculations/' + this.project.id});
      }else{
        this.editGeneralSettings = false, this.calculation.openEditModal = false
      }
    }

    
  }
}
</script>

<style scoped>


</style>